/// <reference path="../typings/index.d.ts" />
declare var Timer: any;
declare var mozHidden: any;
declare var chrome: any;

namespace App.Modulos {
    export class Sniper {
        public static inicializar() {
            var sniper = new App.Sniper();
            sniper.inicializarEventos();
        }
    }
}

namespace App {
    export class Sniper {
        private ajax: IAjax;
        public static urlAppFut = 'https://www.ea.com/pt-br/fifa/ultimate-team/web-app/';
        //FORM SNIPER
        public static elFormCompra: JQuery = $("#formCompra");
        private elSniperPage: JQuery = $("#sniperPage");

        private static elBtSnipar: JQuery = $(".botao-snipar");
        private elBtLimparlog: JQuery = $(".limpar-log");
        private static elSpinner: JQuery = $("#spinnerSniper");
        private static elSpinnerCancelar: JQuery = $(".loading-cancelar");
        private elBtnPararSniper: JQuery = $(".parar-sniper");
        private elCampoMinimo: JQuery = $("input[name=minimo]");
        private elCampoMinFiltro: JQuery = $("input[name=min]");
        private elCampoJogador: JQuery = $("#jogador");
        private elCampoTela: JQuery = $("#tela");
        private elCampoValorMaximo: JQuery = $("input[name=max]");
        private elCampoValorVenda: JQuery = $("input[name=valor_venda]");
        private elCampoValorLanceMinimoVenda: JQuery = $("input[name=valor_lance_minimo]");
        private elCampoClube: JQuery = $("select[name=time]");
        private elCampoLiga: JQuery = $("select[name=liga]");
        private elCampoNacionalidade: JQuery = $("select[name=pais]");
        private elCampoQualidade: JQuery = $("select[name=qualidade]");
        private elCampoRaridade: JQuery = $("select[name=raridade]");
        private elCampoEstilo: JQuery = $("select[name=estilo]");
        private elCampoTrocaPosicao: JQuery = $("select[name=troca_posicao]");
        private elCampoPosicao: JQuery = $("select[name=posicao]");
        public static elCampoNoUiSliderMaxCompras: any = null;
        public static elCampoNoUiSliderVelocidade: any = null;
        public static elCampoNoUiSliderTentativas: any = null;
        public static elCampoNoUiSliderIntervaloDescanso: any = null;
        public static elCampoNoUiSliderProgramarCompra: any = null;
        public static elCampoNoUiSliderPorcentagemMaisBarato: any = null;
        //CONSUMÍVEIS
        private elCampoCategoria: JQuery = $("select[name=categoria]");
        private elConferenciaCategoria: JQuery = $(".conferencia-consumivel");
        //CARRINHO SNIPER
        private elInfoOferta: JQuery = $(".info-oferta");
        private elAtivarVendaAutomatica: JQuery = $("#ativarVendaAutomatica");
        private elConferenciaJogador: JQuery = $(".conferencia-jogador");
        private elConferenciaQualidade: JQuery = $(".conferencia-qualidade");
        private elConferenciaRaridade: JQuery = $(".conferencia-raridade");
        private elConferenciaPosicao: JQuery = $(".conferencia-posicao");
        private elConferenciaEstilo: JQuery = $(".conferencia-estilo");
        private elConferenciaTrocaPosicao: JQuery = $(".conferencia-troca");
        private elConferenciaPais: JQuery = $(".conferencia-nacionalidade");
        private elConferenciaLiga: JQuery = $(".conferencia-liga");
        private elConferenciaTime: JQuery = $(".conferencia-clube");
        private elBtSniperProgramado: JQuery = $(".bt-sniper-programado");
        private elBtIncrement: JQuery = $(".increment");
        private elBtDecrement: JQuery = $(".decrement");

        private elLinkSalvarFiltroIndisponivel: JQuery = $("#linkSalvarFiltroIndisponivel");
        private elLinkFiltrosIndisponiveis: JQuery = $("#linkFiltrosIndisponiveis");
        private elLinkLimparJogadoresElenco: JQuery = $("#linkLimparJogadoresElenco");
        private elBotaoIniciarAtualizacaoJogadoresElenco: JQuery = $("#botaoIniciarInformacaoJogadoresElenco");

        public static loopTentativas: any;
        public static loopIntervaloProgramado: any;
        public static tempoParaFinalizarLoopProgramado: any;
        public static loopHabilitado: boolean = false;
        public static sniperAtivo: boolean = true;
        public static sniperProgramado: boolean;
        public static sniperTravado: number;
        public static listaNaoAtribuidosBloqueada: boolean = false;
        public static vendaAutomaticaAtiva: boolean;
        public static ehPadrao: boolean;
        public static ehVendaCoins: boolean;
        public static ehConsumiveis: boolean;
        public static ehJogadorEspecial: boolean;
        public static ehAnaliseClube: boolean;
        public static valorMinimo: number = 100;
        public static errorsSequencia: any;
        public static errorsCompraSequencia: any;
        public static passoPagina: string = null;
        public static indiceQuantidadePaginas: number = 1;
        public static descansoDeCompra: number = 0;
        public static acionadoPeloUsuario: boolean = false;
        public static movimentandoItens: boolean = false;
        //CONFIGURACOES FILTROS
        public static tempoProgramado: number;
        public static tempoIntervaloEntreTentativas: number;
        public static quantidadeMaximaCompras: number;
        public static quantidadeMaximaTentativasPorVez: number;
        public static cronometro: any;
        public static arrayItensVendaAutomatica: any;
        public static arrayLoopTentativas: any;
        public static arrayLoopLimpezaListaObs: any;
        public static arrayLoopIntervalos: any;
        public static vendaAutomaticaBloqueada: boolean;
        public static valorCoinMin: number = 150;
        public static valorCoinMax: number = 15000000;
        public static itensExpiradosOuComprados: any;
        public static eventoAppLoadStart: number = 1;
        public static eventoAppContextoStart: number = 2;
        public static eventoAppContextoStop: number = 3;
        public static eventoAppEncontrouItens: number = 4;
        public static eventoAppTelaTransferencia: number = 5;
        public static eventoAppHome: number = 6;
        public static dadosContaEa: IContaEa = null;
        public static dadosUserInfoEa: any = {};
        public static dadosListaTransferenciaEa: any = {};
        public static capacidadeListaDeObservacao: number = 0;
        public static capacidadeLimiteListaDeObservacao: number = 0;
        public static capacidadeHumanaListaDeObservacao: number = 5;
        public static quantidadeAtualListaDeObservacao: number = 0;
        public static quantidadeDisponivelListaDeObservacao: number = 0;
        public static capacidadeListaDeTransferencia: number = 0;
        public static quantidadeAtualListaDeTransferencia: number = 0;
        public static quantidadeDisponivelListaDeTransferencia: number = 0;
        public static tentando: boolean = false;
        public static configuracoesAtuais: any = null;
        private objFiltro: IFiltro = null;
        private dadosForm: any = null;
        private idExtensao: string = null;
        public static maxbInicial: number = 200;
        private tempoAcrescimoTentativa: number = 500;
        private static testeSniper: ITesteSniper = {};
        public static contexto: any = null;
        public static testeSucesso: boolean = false;
        public static messages: ILocateMessages;
        private canalNotificacaojogadorEspecial: string = "spre";
        private modoCompraElencoDme: boolean = false;
        public static totalGastoCompraDme: number = 0;
        public static arrayJogadoresClube: any = [];
        public static keyStorageJogadoresClube: string = "fsw_array_jogadores_clube_";
        public static keyStorageUltimaAtualizacaoJogadoresClube: string = "fsw_array_ultima_atualizacao_jogadores_clube_";
        private static processoInformacaoJogadoresElenco: IProcessoInformacaoJogadoresElenco = { processoIniciado: false, webAppAtualizado: false, jogadoresInformados: false };
        private totalJogadoresGuardadosClube: number = null;
        private snipadas: any = [];
        public static players: any = null;
        public static objJogadorDefault: any = { "f": "Não", "id": 0, "l": "Identificado", "r": 0 };

        /**
         * Solucoes de problemas
         */
        private elementoPassoAutenticacao: JQuery = $("#autenticacao");
        private elementoPassoExtensaoInstalada: JQuery = $("#extensaoInstalada");
        private elementoPassoExtensaoAtualizada: JQuery = $("#extensaoAtualizada");
        private elementoPassoBuscaDeItem: JQuery = $("#buscaDeItem");
        private elementoPassoCompraDeItem: JQuery = $("#compraDeItem");
        private elementoBotaoTesteProblemas: JQuery = $("#botaoTesteProblemas");
        private elementoBotaoLimparCache: JQuery = $("#btnFswlimparCache");
        private elementoEspacoLimparCache: JQuery = $("#conteudoLimpezaCompleta");

        /**
         * Processo informação de jogadores do elenco
         */
        private elementoPassoInciadoProcessoInformacaoElenco: JQuery = $("#passoIniciarProcessoInformacaoJogadoresElenco");
        private elementoPassoCarregamentoWebApp: JQuery = $("#passoCarregamentoWebApp");
        private elementoPassoIdentificacaoJogadoresClube: JQuery = $("#passoIdentificacaoJogadoresClube");

        private elBtnAutenticar: JQuery = $(".btn-autenticar-conta");

        public static contasEa: any = [];
        private autenticando: boolean = false;
        public static coinsTotal: number | any = 0;
        private banometro: any = null;

        public inicializarEventos() {
            if ($('body').data('contexto') == 'site') {
                return;
            }
            let ehNavegadorMobileFuncionando = isMobile.any && !App.Util.strContains(navigator.userAgent, $('#sniperPage').data('navegadoresMobile').split(','));
            App.Sniper.elBtSnipar.prop('disabled', true);
            var bloquearDebug = new BloquearDebug();
            bloquearDebug.bloquearDepuracao((App.Util.isset(App.Util.config) && !App.Util.empty(App.Util.config) && App.Util.config.hasOwnProperty('habilitarConsoleDebug') ? App.Util.config.habilitarConsoleDebug : false));
            if (ehNavegadorMobileFuncionando) {
                window.location.href = '/ajuda/usar-no-celular';
                return;
            }

            App.Sniper.elBtSnipar.on('click', () => {
                this.limparInfoTentativasEcompras();
                App.Sniper.elFormCompra.submit();
            });
            if (App.Util.config.naoValidarPlano) {
                App.Sniper.elFormCompra.on('submit', (e) => { e.preventDefault(); this.aoSnipar(e); });
            } else {
                App.Sniper.elFormCompra.on('submit', (e) => { this.validarPlano(e); });
            }
            this.elBtnPararSniper.on('click', (e) => { this.aoPararCompra(e); });
            this.elBtLimparlog.on('click', (e) => { this.aoLimparLog(e); });
            this.elBotaoIniciarAtualizacaoJogadoresElenco.on('click', (e) => { this.aoIniciarProcessoInformacaoJogadoresDoElenco(e); });

            var timer: number = 0;
            this.elBtIncrement.on('click', (e) => { this.aoIncrementarValor(e); });
            this.elBtDecrement.on('click', (e) => { this.aoDecrementarValor(e); });
            this.elBtIncrement.on("mousedown", (e) => {
                timer = setInterval(() => {
                    this.aoIncrementarValor(e);
                }, 120);
            }).on("mouseup mouseleave", () => {
                clearInterval(timer);
            });
            this.elBtDecrement.on("mousedown", (e) => {
                timer = setInterval(() => {
                    this.aoDecrementarValor(e);
                }, 120);
            }).on("mouseup mouseleave", () => {
                clearInterval(timer);
            });
            this.elLinkSalvarFiltroIndisponivel.on('click', () => { this.aoClicarLinkFiltrosIndisponiveis(); });
            this.elLinkFiltrosIndisponiveis.on('click', () => { this.aoClicarLinkFiltrosIndisponiveis(); });

            this.elCampoJogador.on('change keyup', (e) => { this.aoInformarJogador(e); });
            this.elCampoClube.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaTime); });
            this.elCampoLiga.on('change keyup', (e) => { this.aoAlterarLiga(e, this.elConferenciaLiga); });
            this.elCampoNacionalidade.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaPais); });
            this.elCampoQualidade.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaQualidade); });
            this.elCampoRaridade.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaRaridade); });

            this.elCampoQualidade.on("select2:select", (e) => { this.aoSelecionarCampoQualidade(e); });
            this.elCampoQualidade.on("select2:unselect", (e) => { this.aoSelecionarCampoQualidade(e); });

            this.elCampoEstilo.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaEstilo); });
            this.elCampoPosicao.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaPosicao); });
            this.elCampoTrocaPosicao.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaTrocaPosicao); });
            this.elCampoValorMaximo.on('change keyup', (e) => { this.aoInformarValor(e); });
            this.elCampoValorVenda.on('change keyup', (e) => { this.aoInformarValorVenda(e); });
            this.elCampoValorMaximo.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
            this.elCampoValorVenda.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
            this.elCampoValorLanceMinimoVenda.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
            this.elCampoMinFiltro.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
            this.elAtivarVendaAutomatica.on('change', (e) => { this.aoSelecionarVendaAutomatica(e); });
            this.elCampoCategoria.on('change keyup', (e) => { this.aoAlterarCategoria(e); });
            $("#collapseOne").on('show.bs.collapse', (e) => { this.aoExibirModoCompraElenco(e) });
            $("#collapseOne").on('hide.bs.collapse', (e) => { this.aoOcultarModoCompraElenco(e) });
            $("#modalInfoAntiBan").on('show.bs.modal', (e) => { this.aoAbrirModalUso(e) });

            this.elBtnAutenticar.on('click', (e) => { this.aoClicarEmAutenticarConta(e) });

            App.Sniper.sniperTravado = 0;
            App.Sniper.sniperProgramado = false;
            App.Sniper.vendaAutomaticaAtiva = false;
            App.Sniper.vendaAutomaticaBloqueada = false;
            App.Sniper.ehPadrao = this.elCampoTela.val() == 1;
            App.Sniper.ehConsumiveis = this.elCampoTela.val() == 2;
            App.Sniper.ehJogadorEspecial = this.elCampoTela.val() == 3;
            App.Sniper.ehAnaliseClube = this.elCampoTela.val() == 4;
            App.Sniper.ehVendaCoins = this.elCampoTela.val() == 5;
            App.Sniper.errorsSequencia = 0;
            App.Sniper.errorsCompraSequencia = 0;
            App.Sniper.sniperAtivo = false;
            App.Sniper.arrayItensVendaAutomatica = [];
            App.Sniper.arrayLoopTentativas = [];
            App.Sniper.arrayLoopLimpezaListaObs = [];
            App.Sniper.arrayLoopIntervalos = [];
            App.Sniper.itensExpiradosOuComprados = [];
            this.canalNotificacaojogadorEspecial = this.modoPotenteDeBuscaDeJogadorEspecial() ? "spr" : "spre";

            var locateMessages = new Locate();
            App.Sniper.messages = locateMessages.getMessages(App.Util.locate);
            App.Util.exibirModalPaginaCarregando();

            App.Sniper.cronometro = new Timer();
            this.ajustarCabecalho();
            this.ajax = new App.Ajax();
            this.inicializarCamposNoUiSlider();
            var salvarFiltro = new SalvarFiltro();
            salvarFiltro.inicializarEventos();
            setTimeout(() => {
                if ($('#idExtensao').val() != "") {
                    this.idExtensao = $('#idExtensao').val();
                }
                try {
                    chrome.runtime.sendMessage(this.idExtensao, { evento: "inst" },
                        (resposta: any) => {
                            if (resposta) {
                                try {
                                    this.inicializarSniper();
                                } catch (e) {
                                    App.Util.ocultarModalPaginaCarregando();
                                    this.exibirMensagemAlertaSwal("Carregamento Incompleto!", "Siga os Passos do Video na Home, instale a extensão FutSniperWeb, Faça login em sua conta EA e só depois disso acesse essa Página, se o problema persistir, mande um e-mail para contato@futsniperweb.com.br com o print de desse ERRO:" + e, "error", "OK", "Fechar", "#2dce89", false);
                                }
                            } else {
                                App.Util.ocultarModalPaginaCarregando();
                                if (ehNavegadorMobileFuncionando) {
                                    setTimeout(() => {
                                        window.location.href = '/ajuda/usar-no-celular';
                                    }, 2700);
                                }
                                this.exibirMensagemAlertaSwal("Extensão não instalada!", "A extensão FutSniperWeb não está instalada no seu navegador ou está desatualizada ou não foi instalada corretamente.", "warning", "Instalar extensão", "Fechar", '#3740FF', true, App.Util.config.urlExtensaoChrome);
                            }
                        });
                }
                catch (err) {
                    if (ehNavegadorMobileFuncionando) {
                        setTimeout(() => {
                            window.location.href = '/ajuda/usar-no-celular';
                        }, 2700);
                    }
                    this.exibirMensagemAlertaSwal("Extensão não instalada ou desatualizada!", "A extensão FutSniperWeb não está instalada no seu navegador ou pode estar desatualizada, instale a extensão ou reinstale se já tiver instalado anteriormente.", "warning", "Instalar extensão", "Fechar", '#3740FF', true, App.Util.config.urlExtensaoChrome);
                    App.Util.ocultarModalPaginaCarregando();
                    return false;
                }
            }, 3500);

            window.addEventListener("fswAtualizarDadosWebApp", (evt: any) => {
                this.atualizarDadosWebApp(evt.detail);
            }, false);

            this.inicializarSolucoesDeProblemas();
        }

        private inicializarSniper() {
            /**
          * Se extensao desatualizada
          */
            if (App.Sniper.ehVersaoDesatualizadaExtensao()) {
                App.Util.ocultarModalPaginaCarregando();
                this.exibirMensagemExtensaoDesatualizada();
                return;
            }

            this.getPlayers(() => {
                this.obterDadosContaAtualAutenticada(() => {
                    if (App.Sniper.ehVendaCoins) {
                        this.inicializarVendaDeCoins();
                    }
                    /**
                    * Se não autenticou
                    */
                    if (!App.Sniper.dadosContaEa || (App.Sniper.dadosContaEa && !App.Sniper.dadosContaEa.autenticada)) {
                        App.Util.ocultarModalPaginaCarregando();
                        App.Sniper.sniperTravado = 1;
                        App.Sniper.exibirMensagemSnipeTravado("Sistema não autenticado, você precisa fazer login no WEB APP da sua conta do FIFA e recarregar novamente essa página");
                        return;
                    }

                    this.inicializarBanometro();

                    this.registrarEvento(App.Sniper.eventoAppLoadStart, 'view_load_app');
                    this.registrarEvento(App.Sniper.eventoAppContextoStart, 'view_context_app');
                    this.handleVisibilityChange();
                    App.Sniper.dadosListaTransferenciaEa = JSON.parse($('#listaTransferencia').val());
                    $("#inputhiddenIdPlataforma").val(App.Util.usuario.id_plataforma.toString());
                    App.Sniper.registrarDadosDaContaEa();
                    this.adicionarJogadoresDasListasNoArrayDeJogadoresDoClube();
                    if (App.Sniper.quantidadeDisponivelListaDeObservacao <= 0) {
                        setTimeout(() => {
                            this.liberarListaDeObservacao();
                        }, 1000);
                    }
                    this.salvarContaEa();
                    if (!App.Util.config.naoValidarPlano) {
                        this.validarPlano(null);
                    } else {
                        App.Util.ocultarModalPaginaCarregando();
                    }
                    App.Sniper.elBtSnipar.prop('disabled', false);
                    this.elementoEspacoLimparCache.show();
                    this.inicializarLimpezaCache();
                    this.removerLinkCarregamentoIncompletoScripts();
                    this.inicializarModoCompraElencoDme();
                    this.inicializarAnaliseDeClube();
                    this.inicializarQuantidadeCompraDiaria();
                });
            });
        }

        private obterDadosContaAtualAutenticada(metodoCallback: any) {
            chrome.runtime.sendMessage(this.idExtensao, { evento: "ctaut" },
                (resultado: any) => {
                    try {
                        App.Sniper.dadosContaEa = resultado.conta;
                        App.Sniper.dadosContaEa.ptf = App.Util.getNomePlataforma(App.Sniper.dadosContaEa.ptf);
                        App.Sniper.dadosUserInfoEa = resultado.userInfo;
                        this.completarObjetoContaEa();
                        metodoCallback();
                        this.atualizarExibicaoClubeAtual();
                    } catch (e) {
                        App.Util.ocultarModalPaginaCarregando();
                        this.exibirMensagemAlertaSwal("Conta EA não Autenticada!", "Siga os Passos do Video na Home, instale a extensão FutSniperWeb, Faça login em sua conta EA e só depois disso acesse essa Página, se o problema persistir, mande um e-mail para contato@futsniperweb.com.br com o print de desse ERRO:" + e, "error", "OK", "Fechar", "#2dce89", false);
                    }
                });
        }

        private completarObjetoContaEa() {
            if (App.Sniper.dadosContaEa && App.Util.empty(App.Sniper.dadosContaEa.clube)) {
                App.Sniper.dadosContaEa.clube = App.Sniper.dadosUserInfoEa.usermassinfo.userInfo.clubName;
            }

            if (App.Sniper.dadosContaEa && App.Util.empty(App.Sniper.dadosContaEa.coins)) {
                App.Sniper.dadosContaEa.coins = App.Sniper.dadosUserInfoEa.usermassinfo.userInfo.credits;
            }
        }

        private inicializarBanometro() {
            if (App.Util.existeElementoNaPagina($("#gauge"))) {
                this.banometro = new TermometroJustGage().inicializarCampo("gauge", "1");
                this.atualizarBanometro();
            }
        }

        private atualizarBanometro() {
            try {
                this.ajax = new Ajax();
                this.ajax.get(App.Util.config.urlDadosUso, { idContaEa: App.Sniper.dadosContaEa.id }, (dadosSucesso: IRespostaSucessoAjx) => {
                    var uso: IUso = dadosSucesso.dadosRetornados;
                    this.banometro.refresh(uso.risco);
                    this.atualizarViewModalBanometro(uso);
                }, (dadosErro: IRespostaErroAjx) => {
                    console.log("erro ao carregar banometro");
                }, null, false);
            } catch (e) {
                console.log("erro ao atualizar banometro");
            }
        }

        private atualizarViewModalBanometro(uso: IUso) {
            var modalInfoBan = $("#modalInfoAntiBan");
            modalInfoBan.find('.info-uso-sequencia-maior').html(uso.horasEmSequencia.maior.toString());
            modalInfoBan.find('.info-uso-sequencia-acumulada').html(uso.horasEmSequencia.acumulada.toString());
            modalInfoBan.find('.info-uso-sequencia-quantidade').html(uso.horasEmSequencia.repetiu.toString());
            modalInfoBan.find('.info-uso-compras').html(uso.quantidadeComprasNasUltimasHoras.toString());
            if (uso.risco < 5) {
                modalInfoBan.find('.icon-shape').removeClass('bg-gradient-red').removeClass('bg-gradient-green').removeClass('bg-gradient-yellow').addClass('bg-gradient-green');
            } else if (uso.risco <= 8) {
                modalInfoBan.find('.icon-shape').removeClass('bg-gradient-red').removeClass('bg-gradient-green').removeClass('bg-gradient-yellow').addClass('bg-gradient-yellow');
            } else {
                modalInfoBan.find('.icon-shape').removeClass('bg-gradient-red').removeClass('bg-gradient-green').removeClass('bg-gradient-yellow').addClass('bg-gradient-red');
            }
        }

        private inicializarCamposNoUiSlider() {
            if (App.Sniper.ehVendaCoins) {
                return;
            }
            App.Sniper.elCampoNoUiSliderMaxCompras = new CampoNoUiSlider().inicializarCampo('sliderQuantidadesMaxCompras', $("input[name=quantidadesMaxCompras]"),
                { 'min': 1, '10%': 2, '20%': 3, '30%': 4, '40%': 5, '50%': 6, '60%': 10, '70%': 11, '80%': 50, 'max': 100 });
            App.Sniper.elCampoNoUiSliderMaxCompras.noUiSlider.on('set', function(values: any, handle: any) {
                var valor = parseInt(values[handle]);
                var showSliderLabelAlert = $("input[name=quantidadesMaxCompras]").data('showSliderLabelAlert');
                if (showSliderLabelAlert) {
                    if (App.Util.inArray(valor.toString(), App.Util.stringParseJsonObject(showSliderLabelAlert))) {
                        $("input[name=quantidadesMaxCompras]").parent('.espaco-slider').find('.slider-label-alert').show();
                    } else {
                        $("input[name=quantidadesMaxCompras]").parent('.espaco-slider').find('.slider-label-alert').hide();
                    }
                }
                $('.info-limite-compra').html(parseInt(values[handle]).toString());
                $('input[name=quantidadesMaxCompras]').val(parseInt(values[handle]));
            });

            App.Sniper.elCampoNoUiSliderVelocidade = new CampoNoUiSlider().inicializarCampo('sliderVelocidade', $("input[name=milesegundos]"),
                { 'min': 1000, '35%': 1400, '60%': 2000, '80%': 4000, 'max': 7000 }, 'rtl');
            App.Sniper.elCampoNoUiSliderVelocidade.noUiSlider.on('set', function(values: any, handle: any) {
                var valor = parseInt(values[handle]);
                var showSliderLabelAlert = $("input[name=milesegundos]").data('showSliderLabelAlert');
                if (showSliderLabelAlert) {
                    if (App.Util.inArray(valor.toString(), App.Util.stringParseJsonObject(showSliderLabelAlert))) {
                        $("input[name=milesegundos]").parent('.espaco-slider').find('.slider-label-alert').show();
                    } else {
                        $("input[name=milesegundos]").parent('.espaco-slider').find('.slider-label-alert').hide();
                    }
                }
                $('input[name=milesegundos]').val(valor);
            });

            App.Sniper.elCampoNoUiSliderTentativas = new CampoNoUiSlider().inicializarCampo('sliderQuantidadesTentativa', $('input[name=quantidadesMaxTentativas]'),
                { 'min': 5, '15%': 10, '30%': 15, '45%': 20, '60%': 25, '75%': 30, 'max': 35 });
            App.Sniper.elCampoNoUiSliderTentativas.noUiSlider.on('set', function(values: any, handle: any) {
                $('input[name=quantidadesMaxTentativas]').val(parseInt(values[handle]));
            });

            if (this.modoHumanoAtivo()) {
                App.Sniper.elCampoNoUiSliderIntervaloDescanso = new CampoNoUiSlider().inicializarCampo('sliderIntervaloDescanso', $("input[name=programarIntervalo]"),
                    { 'min': 0, '25%': 1, '55%': 2, '80%': 3, 'max': 4 });
            } else {
                App.Sniper.elCampoNoUiSliderIntervaloDescanso = new CampoNoUiSlider().inicializarCampo('sliderIntervaloDescanso', $("input[name=programarIntervalo]"),
                    { 'min': 0, '20%': 1, '40%': 2, '60%': 4, '80%': 6, 'max': 8 });
            }


            App.Sniper.elCampoNoUiSliderIntervaloDescanso.noUiSlider.on('set', function(values: any, handle: any) {
                var valor = parseInt(values[handle]);
                var showSliderLabelAlert = $("input[name=programarIntervalo]").data('showSliderLabelAlert');
                if (showSliderLabelAlert) {
                    if (App.Util.inArray(valor.toString(), App.Util.stringParseJsonObject(showSliderLabelAlert))) {
                        $("input[name=programarIntervalo]").parent('.espaco-slider').find('.slider-label-alert').show();
                    } else {
                        $("input[name=programarIntervalo]").parent('.espaco-slider').find('.slider-label-alert').hide();
                    }
                }
                $('input[name=programarIntervalo]').val(valor);
            });

            if (this.uso3HorasHabilitado()) {
                App.Sniper.elCampoNoUiSliderProgramarCompra = new CampoNoUiSlider().inicializarCampo('sliderTempoProgamado', $("input[name=programarCompra]"),
                    { 'min': 0, '20%': 10, '40%': 30, '60%': 60, '80%': 120, 'max': 180 });
            } else {
                App.Sniper.elCampoNoUiSliderProgramarCompra = new CampoNoUiSlider().inicializarCampo('sliderTempoProgamado', $("input[name=programarCompra]"),
                    { 'min': 0, '30%': 10, '50%': 30, '70%': 60, 'max': 120 });
            }

            App.Sniper.elCampoNoUiSliderProgramarCompra.noUiSlider.on('set', (values: any, handle: any) => {
                $('input[name=programarCompra]').val(parseInt(values[handle]));
                this.aoProgramarSniper(parseInt(values[handle]));
            });

            if (App.Sniper.ehPadrao) {
                App.Sniper.elCampoNoUiSliderPorcentagemMaisBarato = new CampoNoUiSlider().inicializarCampo('sliderPorcentagemMaisBarato', $("input[name=porcentagem_mais_barato]"),
                    { 'min': 0, '10%': 5, '20%': 10, '30%': 15, '40%': 20, '50%': 25, '60%': 30, '70%': 35, '80%': 40, '90%': 45, 'max': 50 });
                App.Sniper.elCampoNoUiSliderPorcentagemMaisBarato.noUiSlider.on('set', function(values: any, handle: any) {
                    $('#slideporcentagemMaisBaratoLabel').html(parseInt(values[handle]).toString())
                    $("input[name=porcentagem_mais_barato]").val(parseInt(values[handle]));
                    if (!App.Util.empty($("#formObterElencoDme").find("input[name=url_elenco_futbin]").val())) {
                        $("#formObterElencoDme").submit();
                    }
                });
            }
        }
        private inicializarAnaliseDeClube() {
            if (App.Sniper.ehAnaliseClube) {
                var analiseClube = new App.AnaliseClube();
                analiseClube.inicializarEventos(this.idExtensao);
            }
        }
        private inicializarModoCompraElencoDme() {
            App.Sniper.keyStorageUltimaAtualizacaoJogadoresClube = App.Sniper.keyStorageUltimaAtualizacaoJogadoresClube + App.Sniper.dadosContaEa.id;
            var ultimaInformacaojogadores = localStorage.getItem(App.Sniper.keyStorageUltimaAtualizacaoJogadoresClube);
            if (ultimaInformacaojogadores) {
                var datahora = new Date(ultimaInformacaojogadores);
                $(".espaco-ultima-informacao-jogadores").show();
                $(".espaco-ultima-informacao-jogadores .datahora-info-jogadores").html(datahora.toLocaleDateString() + " " + datahora.toLocaleTimeString());
                $("#botaoProcessarUrlDmeFutbin").attr('type', 'submit').removeAttr('href').removeAttr('data-toggle').removeAttr('data-target');
            } else {
                $(".espaco-ultima-informacao-jogadores").hide();
                $("#botaoProcessarUrlDmeFutbin").attr('type', 'button').attr('href', '#informarJogadoresElenco').attr('data-toggle', 'modal').attr('data-target', '#informarJogadoresElenco');
                $(".espaco-ultima-informacao-jogadores .datahora-info-jogadores").html();

            }
            if (App.Util.elencoDme) {
                this.modoCompraElencoDme = true;
                this.adicionarElencoDeDme(App.Util.elencoDme.elenco);
                $('#jogador').on('select2:unselecting', (e) => {
                    this.addInfoPrecoSelectJogadores(App.Util.elencoDme.elenco);
                    this.objFiltro = this.getObjetoFiltros(e);
                });

                App.Sniper.elCampoNoUiSliderMaxCompras.noUiSlider.set(11);
                App.Sniper.elCampoNoUiSliderMaxCompras.setAttribute('disabled', true);
                App.Sniper.elCampoNoUiSliderVelocidade.noUiSlider.set(4000);
                App.Sniper.elCampoNoUiSliderTentativas.noUiSlider.set(10);
                App.Sniper.elCampoNoUiSliderIntervaloDescanso.noUiSlider.set(0);
                App.Sniper.elCampoNoUiSliderProgramarCompra.noUiSlider.set(60);

                $('#conteudoOfertaCompra').hide();
                $('#conteudoSalvarFiltro').hide();
                $('#conteudoGeralVendaAutomatica').hide();

                $('#conteudoDescansoEntreTentativas').hide();
                $('#espacoConteudoComposFiltros').hide();
                App.Sniper.elBtSnipar.html('Snipar Elenco');
            }
        }
        private adicionarJogadoresDasListasNoArrayDeJogadoresDoClube() {
            App.Sniper.keyStorageJogadoresClube = App.Sniper.keyStorageJogadoresClube + App.Sniper.dadosContaEa.id;
            if (!App.Util.empty(App.Util.getArrayStorage(App.Sniper.keyStorageJogadoresClube))) {
                App.Sniper.arrayJogadoresClube = App.Util.getArrayStorage(App.Sniper.keyStorageJogadoresClube);
            }

            if (App.Sniper.quantidadeAtualListaDeObservacao > 0) {
                this.atualizarJogadoresClube(App.Sniper.dadosUserInfoEa.usermassinfo.purchasedItems.itemData);
            }
            if (App.Sniper.quantidadeAtualListaDeTransferencia > 0) {
                this.atualizarJogadoresClube(App.Sniper.dadosListaTransferenciaEa.auctionInfo);
            }
        }

        public static ehVersaoDesatualizadaExtensao() {
            var versaoExtensaoInstalada = parseInt($('#versaoExtensao').val().replace('.', ''))
            var versaoExtensaoAtual = parseInt(App.Util.config.versaoAtualExtensaoChrome.replace('.', ''))
            return versaoExtensaoAtual > versaoExtensaoInstalada;
        }

        private static iniciarCronometro(tempo: number) {
            App.Sniper.cronometro.start({ countdown: true, startValues: { seconds: tempo } });
            $('.cronometro .values').html(App.Sniper.cronometro.getTimeValues().toString());
            App.Sniper.cronometro.addEventListener('secondsUpdated', function(e: JQueryEventObject) {
                $('.cronometro .values').html(App.Sniper.cronometro.getTimeValues().toString());
            });
            App.Sniper.cronometro.addEventListener('started', function(e: JQueryEventObject) {
                $('.cronometro').show();
            });
            App.Sniper.cronometro.addEventListener('stopped', function(e: JQueryEventObject) {
                $('.cronometro .values').html('00:00:00');
            });
            App.Sniper.cronometro.addEventListener('targetAchieved', function(e: JQueryEventObject) {
                $('.cronometro .values').html('00:00:00');
            });
        }

        private ajustarCabecalho() {
            $(window).scroll(function() {
                var scroll = $(window).scrollTop();
                if (scroll > 50) {
                    $('#navbar-main').hide();
                } else {
                    $('#navbar-main').show();
                }
            });
        }
        private exibirMensagemAlertaSwal(title: string, mensagem: string, tipo: string = "error", confirmButtonText: string = "OK", cancelButtonText: string = "Fechar", confirmButtonColor: string = "#FB6340", showCancelButton: boolean = true, urlRedirectClickConfirm: string = null, footer: string = null, contaEaJaVinculada: any = null) {
            var objSwal: any = {
                title: title,
                html: mensagem,
                type: tipo,
                confirmButtonText: confirmButtonText,
                confirmButtonColor: confirmButtonColor,
                showCancelButton: showCancelButton,
                cancelButtonText: cancelButtonText
            }
            if (footer) {
                objSwal.footer = footer;
            }
            swal(objSwal).then((result: any) => {
                if (result.hasOwnProperty('value') && result.value && urlRedirectClickConfirm) {
                    window.location.href = urlRedirectClickConfirm;
                    return;
                }
                if (result.hasOwnProperty('value') && result.value && contaEaJaVinculada) {
                    this.revincularContaEa(contaEaJaVinculada);
                    return;
                }
            });
        }

        public static exibirMensagemSnipeTravado(mensagem: string = "Sistema travado por segurança, você precisa fazer uma nova autenticação ou o seu mercado pode estar bloqueado temporariamente ou então pode ser um pedido de captcha, verifique no seu WEB APP.") {
            swal({
                title: "Atenção!",
                text: mensagem,
                type: "error",
                showCancelButton: true,
                confirmButtonText: "Autenticar",
                confirmButtonColor: '#FB6340',
                cancelButtonText: "Fechar"
            }).then(function(result: any) {
                if (result.hasOwnProperty('value') && result.value) {
                    window.location.href = App.Sniper.urlAppFut;
                    return;
                }
            });
        }
        private exibirMensagemExtensaoDesatualizada() {
            swal({
                title: "Extensão desatualizada!",
                text: "Existe uma versão mais nova da extensão FutSniperWeb, é importante que você remova e instale novamente a versão " + App.Util.config.versaoAtualExtensaoChrome,
                type: "info",
                showCancelButton: false,
                confirmButtonText: "Atualizar",
                confirmButtonColor: '#3740FF'
            }).then(function(result: any) {
                if (result.hasOwnProperty('value') && result.value) {
                    window.location.href = App.Util.config.urlExtensaoChrome;
                    return;
                }
            });
        }
        private exibirMensagemManutensao() {
            swal({
                title: "Desculpa, Estamos em manutenção!",
                text: "Por favor aguarde um pouco até que as nossas atualizações sejam concluídas para você voltar a snipar com segurança",
                type: "info",
                showCancelButton: false,
                confirmButtonText: "Ok",
                confirmButtonColor: '#3740FF'
            }).then(function(result: any) {

            });
        }
        private exibirMensagemItensInegociaveisOcupandoLista() {
            swal({
                title: "Lista de não atribuídos cheia!",
                text: "Você precisa liberar itens inegociáveis que estão tomando conta do espaço em sua lista de itens não atribuídos e sincronizar novamente o WebApp com o FutSniperWeb",
                type: "warning",
                showCancelButton: false,
                confirmButtonText: "Ok",
                confirmButtonColor: '#f89500'
            }).then(function(result: any) {

            });
        }
        private exibirMensagemVersaoNavegadorIncompativel(versao: number) {
            swal({
                title: "Versão incompatível do navegador!",
                text: "A ferramenta não está funcionando corretamente com a versão " + versao + " do chrome que você está usando, por favor remova essa versão e instale uma versão anterior do chrome, de preferência a versão 75, estamos trabalhando para fazer funcionar na versao " + versao,
                type: "error",
                showCancelButton: false,
                confirmButtonText: "Ver outras versões do chrome",
                confirmButtonColor: '#3740FF'
            }).then(function(result: any) {
                if (result.hasOwnProperty('value') && result.value) {
                    window.location.href = "https://www.slimjet.com/chrome/google-chrome-old-version.php";
                    return;
                }

            });
        }
        private exibirMensagemSemCapacidadeNasListasDeTranferencia() {
            swal({
                title: "Atenção!",
                text: "Não há espaço em sua lista de itens não atribuidos e nem na lista de transferência, libere espaço nas suas listas e atualize as páginas do WEB APP e FUTSNIPERWEB novamente",
                type: "error",
                showCancelButton: true,
                confirmButtonText: "Ok, vou liberar espaço",
                confirmButtonColor: '#FB6340',
                cancelButtonText: "Fechar"
            });
        }
        private variarFiltro(minimo: number) {
            minimo += 50;
            var valorMaximo = App.Util.obterInteiroDaString(this.elCampoValorMaximo.val());
            var valorAserSubtraido = 50;

            if (valorMaximo == 200) {
                valorAserSubtraido = 0;
            }

            if (minimo > (valorMaximo - valorAserSubtraido) || minimo > 400) {
                minimo = 150;
            }
            return minimo;
        }

        private variarFiltroAvancado(minimo: number) {
            minimo = App.Util.incrementarValorDeFiltro(minimo);
            var valorMaximo = App.Util.obterInteiroDaString(this.elCampoValorMaximo.val());
            var valorMinimoParaFiltro = this.getValorMinimoFiltro();
            var valorAserSubtraido = App.Util.obterIncrementoValorFiltro(minimo);

            if (valorMaximo == 200) {
                valorAserSubtraido = 0;
            }

            if (minimo > (valorMaximo - valorAserSubtraido) || (valorMinimoParaFiltro && minimo >= valorMinimoParaFiltro) || minimo >= App.Util.obterLimiteVariacaoFiltroPorValorCompra(valorMaximo)) {
                minimo = 150;
            }
            return minimo;
        }

        private inicializarConfiguracoes() {
            App.Sniper.tempoProgramado = App.Sniper.getTempoProgramadoSniper();
            App.Sniper.tempoIntervaloEntreTentativas = App.Sniper.getTempoIntervaloEntreTentativas();
            App.Sniper.quantidadeMaximaCompras = App.Sniper.getQuantidadeMaxCompras();
            App.Sniper.quantidadeMaximaTentativasPorVez = App.Sniper.getQuantidadeMaxTentativasPorVez();
            App.Sniper.configuracoesAtuais = $('#conteudoConfiguracoes input[type=hidden]').serializeArray();
        }

        private getQuantidadeCompras(): number {
            return App.Util.obterInteiroDaString($('.quantidade-compras').html());
        }
        private getQuantidadeTentativas(): number {
            return App.Util.obterInteiroDaString($('.tentativas').html());
        }
        private static getQuantidadeMaxTentativasPorVez(): number {
            let resultado = parseInt($("input[name='quantidadesMaxTentativas']").val());
            if (App.Util.empty(resultado)) {
                return 0;
            }
            return resultado;
        }
        public static getTempoIntervaloEntreTentativas(): number {
            let resultado = parseInt($("input[name='programarIntervalo']").val());
            if (App.Util.empty(resultado)) {
                return 0;
            }
            return resultado;
        }
        public static getTempoProgramadoSniper(): number {
            let resultado = parseInt($("input[name='programarCompra']").val());
            if (App.Util.empty(resultado)) {
                return 0;
            }
            return resultado;
        }
        private static getQuantidadeMaxCompras(): number {
            let resultado = parseInt($("input[name='quantidadesMaxCompras']").val());
            if (App.Util.empty(resultado)) {
                return 1;
            }
            return resultado;
        }
        private getMilesegundos(): number {
            let resultado = parseInt($("input[name='milesegundos']").val());
            if (App.Util.empty(resultado)) {
                return 4000;
            }
            return resultado;
        }
        private getValorMinimoFiltro(): number {
            let resultado = App.Util.empty(this.elCampoMinFiltro.val()) ? null : parseInt(this.elCampoMinFiltro.val());
            if (App.Util.empty(resultado)) {
                return null;
            }
            return resultado;
        }

        public static runAudio(idAudio: number = 1) {
            if (!$("#formCompra").data('audio')) {
                return;
            }
            switch (idAudio) {
                case 1:
                    App.Util.playAudioCompra();
                    break;
                case 2:
                    App.Util.playAudioParouCompra();
                    break;
            }

        }

        public static habilitarPossibilidadeDeSnipar() {
            $(".loading").hide();
            App.Sniper.elBtSnipar.prop('disabled', false);
            App.Sniper.ocultarLoadingSniperApp();
        }

        private addQuantidadeTentativas() {
            $('.tentativas').html((App.Util.obterInteiroDaString($('.tentativas').html()) + 1).toString());
        }
        private addQuantidadeCompras(itemComprado: any) {
            App.Sniper.runAudio();
            toastr.success("Snipado por: " + itemComprado.buyNowPrice, "Parabéns!");
            if (App.Sniper.ehConsumiveis) {
                $("#espacoLogs").prepend(App.Sniper.getConteudoLogSnipou(itemComprado));
            } else {
                App.Sniper.salvarLogSnipouJogador($("#espacoLogs"), itemComprado);
            }
            if (App.Util.existeElementoNaPagina($('.quantidade-compras'))) {
                $('.quantidade-compras').html((App.Util.obterInteiroDaString($('.quantidade-compras').html()) + 1).toString());
                $('.progress-compras').css('width', ((App.Util.obterInteiroDaString($('.quantidade-compras').html()) / App.Sniper.quantidadeMaximaCompras) * 100).toString() + '%');
            }
            this.incrementarQuantidadeCompraDiaria();
        }
        private processarDisponibilidadesDeListas() {
            this.decrementarQuantidadeDisponivelListaDeObservacao();
            var quantidadeMinimaParaLiberarEspacoNaListaDeObservacao = (App.Sniper.vendaAutomaticaAtiva && App.Sniper.arrayItensVendaAutomatica.length > 0) ? 3 : 0;
            if (App.Sniper.quantidadeDisponivelListaDeObservacao <= quantidadeMinimaParaLiberarEspacoNaListaDeObservacao) {
                toastr.info("Liberando espaço na lista de itens não atribuídos");
                this.liberarListaDeObservacao();
            }
        }
        public pararTudo(naoLiberarListaobservacao: boolean = false) {
            if (!naoLiberarListaobservacao && App.Sniper.quantidadeDisponivelListaDeTransferencia > 0 && App.Sniper.vendaAutomaticaAtiva && App.Sniper.arrayItensVendaAutomatica.length > 0 && !App.Sniper.acionadoPeloUsuario) {
                this.liberarListaDeObservacao();
            }
            //Salvar as snipadas acumuladas
            if (this.snipadas.length > 0) {
                this.ajax.postAcaoSemResposta(App.Util.config.urlSalvarSniper, { array_snipadas: this.snipadas });
                this.snipadas = [];
                try {
                    this.atualizarBanometro();
                } catch (e) {
                    console.log("Erro ao atualizar Banômetro", e);
                }
            }

            App.Sniper.sniperAtivo = false;
            if (App.Sniper.sniperProgramado) {
                App.Sniper.finalizarSniperProgramado(false);
                return;
            }
            App.Sniper.finalizarLoopsAutomaticos();
        }

        public static finalizarLoopsAutomaticos() {
            clearInterval(App.Sniper.loopIntervaloProgramado);
            clearTimeout(App.Sniper.tempoParaFinalizarLoopProgramado);
            clearInterval(App.Sniper.loopTentativas);
            App.Sniper.finalizarTentativasSniper();
            App.Sniper.habilitarPossibilidadeDeSnipar();
            $("#espacoLogs").prepend(App.Sniper.getConteudoLogSniperParado());
        };

        public static finalizarSniperProgramado(exibirLogTempo: boolean = true) {
            clearInterval(App.Sniper.loopIntervaloProgramado);
            clearTimeout(App.Sniper.tempoParaFinalizarLoopProgramado);
            App.Sniper.sniperAtivo = false;
            App.Sniper.sniperProgramado = false;
            if (exibirLogTempo) {
                $("#espacoLogs").prepend(App.Sniper.getConteudoLogLimiteTempoProgramado());
            }
            App.Sniper.cronometro.stop();
            App.Sniper.finalizarLoopsAutomaticos();
        }
        private static finalizarTentativasSniper() {
            $.each(App.Sniper.arrayLoopTentativas, function(index, value) {
                window.clearInterval(value);
            });
            App.Sniper.arrayLoopTentativas = [];
        }
        private static finalizarLoopLimpezaListaObsSniper() {
            $.each(App.Sniper.arrayLoopLimpezaListaObs, function(index, value) {
                window.clearInterval(value);
            });
            App.Sniper.arrayLoopLimpezaListaObs = [];
        }

        private static finalizarLoopIntervalo() {
            $.each(App.Sniper.arrayLoopIntervalos, function(index, value) {
                window.clearInterval(value);
            });
            App.Sniper.arrayLoopIntervalos = [];
        }

        private aoPararCompra(e: JQueryEventObject) {
            this.pararCompra();
        }

        private pararCompra(acionadoPeloUsuario: boolean = true) {
            if (App.Sniper.sniperAtivo) {
                App.Sniper.elSpinnerCancelar.show();
                App.Sniper.acionadoPeloUsuario = acionadoPeloUsuario;
                this.pararTudo();
                App.Sniper.habilitarPossibilidadeDeSnipar();

                App.Sniper.elSpinnerCancelar.hide();
            }
        }

        private aoLimparLog(e: JQueryEventObject) {
            $("#espacoLogs").html('');
        }
        private aoIniciarProcessoInformacaoJogadoresDoElenco(e: JQueryEventObject) {
            $("#botaoIniciarInformacaoJogadoresElenco").html($("#botaoIniciarInformacaoJogadoresElenco").data('textLoad'));
            this.proximaVerificacao(this.elementoPassoInciadoProcessoInformacaoElenco, this.iniciarPassoProcessoInformacaoJogadoresElenco,
                () => {
                    this.proximaVerificacao(this.elementoPassoCarregamentoWebApp, () => { return true },
                        () => {
                            chrome.runtime.sendMessage(this.idExtensao, { evento: "rcwpp" }, (resposta: any) => { });
                            $(this.elementoPassoIdentificacaoJogadoresClube).find('.badge-aguardando').hide();
                            $(this.elementoPassoIdentificacaoJogadoresClube).find('.badge-loading').show();
                        });
                });
        }
        private iniciarPassoProcessoInformacaoJogadoresElenco() {
            if (!App.Sniper.processoInformacaoJogadoresElenco.processoIniciado) {
                $("#botaoIniciarInformacaoJogadoresElenco").prop('disabled', true);
                App.Sniper.processoInformacaoJogadoresElenco.processoIniciado = true;
                App.Util.setArrayStorage(App.Sniper.keyStorageJogadoresClube, []);
                App.Sniper.arrayJogadoresClube = [];
            }
            return true;
        }

        private finalizarProcessoInformacaoJogadoresElenco() {
            if (App.Sniper.processoInformacaoJogadoresElenco.processoIniciado) {
                this.proximaVerificacao(this.elementoPassoIdentificacaoJogadoresClube, () => { return true },
                    () => {
                        var datahora = new Date();
                        $(".espaco-ultima-informacao-jogadores").show();
                        $(".espaco-ultima-informacao-jogadores .datahora-info-jogadores").html(datahora.toLocaleDateString() + " " + datahora.toLocaleTimeString());
                        localStorage.setItem(App.Sniper.keyStorageUltimaAtualizacaoJogadoresClube, datahora.toISOString());
                        $("#botaoProcessarUrlDmeFutbin").attr('type', 'submit').removeAttr('href').removeAttr('data-toggle').removeAttr('data-target');
                        $("#botaoIniciarInformacaoJogadoresElenco").html($("#botaoIniciarInformacaoJogadoresElenco").data('textInit'));
                        $("#botaoIniciarInformacaoJogadoresElenco").prop('disabled', false);
                        $("#processoInformarJogadoresClubeCompleto").show();
                        $("#abaLog").click();
                        $("#espacoLogs").prepend(App.Sniper.getConteudoLogListaDeJogadoresClubeAtualizada());
                        App.Sniper.processoInformacaoJogadoresElenco.processoIniciado = false;
                        setTimeout(() => {
                            $("#processoInformarJogadoresClubeCompleto").hide();
                        }, 30000);
                    });
            }
        }

        private aoInformarJogador(e: JQueryEventObject) {
            var quantidadeJogadores = 0;
            var nomes = $.map($(e.target).select2('data'), function(obj) {
                if (obj.hasOwnProperty('text') && obj.text != "") {
                    obj = JSON.parse(obj.text);
                }
                var nomeJogador = '';
                if (obj.hasOwnProperty('name')) {
                    nomeJogador = obj.name;
                } else {
                    nomeJogador = obj.hasOwnProperty('c') ? obj.c : obj.f + ' ' + obj.l;
                }
                quantidadeJogadores++;
                return '<span id="nomeItem' + obj.id + '">' + nomeJogador + '</span>';
            }).join(', ');
            var id = $(e.target).val();
            var texto: string = nomes;
            var span = this.elConferenciaJogador.find('span');
            span.html(" - ");
            if (App.Util.empty(id)) {
                return;
            }
            span.html(texto);
        }

        private aoAlterarCampoSelect(e: JQueryEventObject, elConferencia: JQuery) {
            var id = $(e.target).val();
            var texto: any = $(e.target).find(':selected').text();
            var img = elConferencia.find('img');
            var span = elConferencia.find('span');
            img.attr('src', "");
            span.html(" - ");
            if (App.Util.empty(id)) {
                return;
            }
            span.html(texto);
            img.attr('src', $(e.target).find(':selected').data('imgSrc'));
        }
        private aoAlterarLiga(e: JQueryEventObject, elConferencia: JQuery) {
            var id = $(e.target).val();
            var texto: any = $(e.target).find(':selected').text();
            if (!App.Util.config.naoValidarPlano && App.Util.inArray(parseInt(id), App.Util.usuario.plano.configuracoes.ligasIndisponiveis)) {
                $('#liga').val('').trigger('change').trigger('select2:select');
                this.exibirMensagemAlertaSwal("Liga indisponível", "A Liga <b>" + texto + "</b> não está disponível no <b>" + this.elSniperPage.data('nomePlano') + "</b>, Essa liga está disponível para assinantes do <b>Plano Ouro</b>.", "warning", "Ver Planos", "Fechar", '#2dce89', true, this.elSniperPage.data('urlPlanos'));
                return;
            }
            var img = elConferencia.find('img');
            var span = elConferencia.find('span');
            img.attr('src', "");
            span.html(" - ");
            if (App.Util.empty(id)) {
                return;
            }
            span.html(texto);
            img.attr('src', $(e.target).find(':selected').data('imgSrc'));
        }
        private aoAlterarCategoria(e: JQueryEventObject) {
            var consumivel = $(e.target).val();
            var texto: any = $(e.target).find(':selected').text();
            var img = this.elConferenciaCategoria.find('img');
            var span = this.elConferenciaCategoria.find('span');
            img.attr('src', "");
            span.html(" - ");
            if (!App.Util.empty(consumivel)) {
                span.html(texto);
                img.attr('src', $(e.target).find(':selected').data('imgSrc'));
            }

            if (consumivel == "fitness") {
                this.elCampoQualidade.val("").trigger('change');
                this.elCampoQualidade.prop('disabled', true);
                this.elCampoQualidade.attr('disabled', 'disabled');
                this.elCampoEstilo.val("").trigger('change');
                this.elCampoEstilo.prop('disabled', true)
                this.elCampoEstilo.attr('disabled', 'disabled');
                this.elCampoTrocaPosicao.val("").trigger('change');
                this.elCampoTrocaPosicao.prop('disabled', true)
                this.elCampoTrocaPosicao.attr('disabled', 'disabled');
                $('[aria-labelledby="select2-qualidade-container"]').attr("style", "");
                $('[aria-labelledby="select2-estilo-container"]').attr("style", "");
                $('[aria-labelledby="select2-trocaPosicao-container"]').attr("style", "");
                $('<input>').attr({
                    type: 'hidden',
                    id: 'tipo',
                    name: 'tipo',
                    value: 'development'
                }).prependTo('form');

                $('<input>').attr({
                    type: 'hidden',
                    id: 'definitionId',
                    name: 'definitionId',
                    value: '5002006'
                }).prependTo('form');
            } else if (consumivel == "position") {
                this.elCampoTrocaPosicao.prop('disabled', false);
                this.elCampoTrocaPosicao.removeAttr('disabled');
                this.elCampoQualidade.val("").trigger('change');
                this.elCampoQualidade.prop('disabled', true);
                this.elCampoQualidade.attr('disabled', 'disabled');
                $('[aria-labelledby="select2-qualidade-container"]').attr("style", "");
                $('[aria-labelledby="select2-estilo-container"]').attr("style", "");
                this.elCampoEstilo.val("").trigger('change');
                this.elCampoEstilo.prop('disabled', true)
                this.elCampoEstilo.attr('disabled', 'disabled');
                $('#tipo').remove();
                $('#definitionId').remove();
            } else {
                this.elCampoQualidade.prop('disabled', false);
                this.elCampoQualidade.removeAttr('disabled');
                this.elCampoEstilo.prop('disabled', false)
                this.elCampoEstilo.removeAttr('disabled');
                this.elCampoTrocaPosicao.val("").trigger('change');
                this.elCampoTrocaPosicao.prop('disabled', true)
                this.elCampoTrocaPosicao.attr('disabled', 'disabled');
                $('[aria-labelledby="select2-trocaPosicao-container"]').attr("style", "");
                $('#tipo').remove();
                $('#definitionId').remove();
            }
        }

        private aoPerderFocoCampoValor(e: JQueryEventObject) {
            var campoName = $(e.target).attr('name');
            var campoContextoValorMin = $(e.target).data('min');

            var valorInformado = App.Util.obterInteiroDaString($(e.target).val());
            valorInformado = valorInformado ? valorInformado : 0;
            switch (campoName) {
                case 'min':
                    valorInformado = valorInformado > App.Sniper.valorCoinMax ? App.Sniper.valorCoinMax : valorInformado;
                    var valorCampoMax = App.Util.obterInteiroDaString(this.elCampoValorMaximo.val());
                    if (valorInformado >= valorCampoMax) {
                        this.elCampoValorMaximo.val(valorInformado < App.Sniper.valorCoinMax ? App.Util.incrementarValorDeFiltro(valorInformado) : App.Sniper.valorCoinMax).trigger('input').trigger('change');
                    }
                    break;
                case 'valor_lance_minimo':
                    valorInformado = valorInformado > App.Sniper.valorCoinMax ? App.Sniper.valorCoinMax : valorInformado;
                    var valorCampoMax = App.Util.obterInteiroDaString(this.elCampoValorVenda.val());
                    if (valorInformado >= valorCampoMax) {
                        this.elCampoValorVenda.val(valorInformado < App.Sniper.valorCoinMax ? App.Util.incrementarValorDeFiltro(valorInformado) : App.Sniper.valorCoinMax).trigger('input').trigger('change');
                    }
                    valorInformado = valorInformado ? valorInformado : 0;
                    break;
                case 'max':
                    var valorCampoMin = App.Util.obterInteiroDaString(this.elCampoMinFiltro.val());
                    if (valorInformado <= valorCampoMin) {
                        var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
                        var valorMinCampo = this.elCampoMinFiltro.data('min');
                        this.elCampoMinFiltro.val(valorCalculado < valorMinCampo ? '' : valorCalculado).trigger('input');
                    }
                    valorInformado = valorInformado && valorInformado >= campoContextoValorMin ? (valorInformado > App.Sniper.valorCoinMax ? App.Sniper.valorCoinMax : valorInformado) : campoContextoValorMin;
                    break;
                case 'valor_venda':
                    var valorCampoMin = App.Util.obterInteiroDaString(this.elCampoValorLanceMinimoVenda.val());
                    if (valorInformado <= valorCampoMin) {
                        var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
                        this.elCampoValorLanceMinimoVenda.val(valorCalculado <= 0 ? '' : valorCalculado).trigger('input');
                    }
                    valorInformado = valorInformado ? (valorInformado > App.Sniper.valorCoinMax ? App.Sniper.valorCoinMax : valorInformado) : 0;
                    break;
            }

            valorInformado = App.Util.tratarValorDeFiltro(valorInformado);
            $(e.target).val(valorInformado ? valorInformado.toString() : '').trigger('input').trigger('change');
        }

        private aoInformarValor(e: JQueryEventObject) {
            var valorInformado = App.Util.obterInteiroDaString($(e.target).val());

            if (valorInformado > 100000) {
                $(e.target).css({ 'background-color': '#ffffff' }).css({ 'color': '#bbc60c' });
                $(e.target).parents('.input-group').find('.input-group-text').css({ 'background-color': '#ffffff' });
                $("#alertValor").show();
            } else {
                $(e.target).css({ 'background-color': '#ffffff' }).css({ 'color': '#38a378' });
                $(e.target).parents('.input-group').find('.input-group-text').css({ 'background-color': '#ffffff' });
                $("#alertValor").hide();
            }

            this.elInfoOferta.html($(e.target).val());
        }

        private aoInformarValorVenda(e: JQueryEventObject) {
            $("#infoVendaAutomaticaLig").attr('data-original-title', 'Vendendo automaticamente por ' + $(e.target).val() + ' coins');
            $('.info-valor-venda-automatica').html($(e.target).val());
        }

        private aoSelecionarVendaAutomatica(e: JQueryEventObject) {
            App.Sniper.vendaAutomaticaBloqueada = false;
            if ($(e.target).is(':checked')) {
                this.habilitarVendaAutomatica();
                if (this.modoManterNoCemiterio()) {
                    swal("Permitido somente quando ìtens são enviados para transferência!", "A venda automática atualmente só é permitida quando os itens são enviados para lista de transferência, desabilite a opção (Manter ítens na lista de não atribuídos) em configurações.", "warning");
                    this.elAtivarVendaAutomatica.prop("checked", false).trigger('change');
                }
            } else {
                this.desabilitarVendaAutomatica();
            }
        }

        private habilitarVendaAutomatica() {
            this.elSniperPage.find('#conteudoVendaAutomatica :input').prop("disabled", false).val("");
            this.elSniperPage.find('#conteudoVendaAutomatica .input-group-prepend').removeClass("disabled");
            $("#infoVendaAutomaticaLig").show();
            $("#infoVendaAutomaticaDeslig").hide();
            App.Sniper.vendaAutomaticaAtiva = true;
            $("#corpoVendaAutomatica").show();
            $("#labelVendaAutomatica").removeClass('text-muted').addClass('text-primary');
        }

        private desabilitarVendaAutomatica() {
            $("#infoVendaAutomaticaLig").hide();
            this.elSniperPage.find('#conteudoVendaAutomatica :input').prop("disabled", true).val("");
            this.elSniperPage.find('#conteudoVendaAutomatica .input-group-prepend').addClass("disabled");
            $("#infoVendaAutomaticaLig").hide();
            $("#infoVendaAutomaticaDeslig").show();
            $('.info-valor-venda-automatica').html('');
            App.Sniper.vendaAutomaticaAtiva = false;
            App.Sniper.arrayItensVendaAutomatica = [];
            $("#corpoVendaAutomatica").hide();
            $("#labelVendaAutomatica").removeClass('text-primary').addClass('text-muted');
        }

        private aoProgramarSniper(valorProgramado: number) {
            App.Sniper.tempoProgramado = valorProgramado;
            if (App.Sniper.tempoProgramado <= 0) {
                this.elBtSniperProgramado.hide();
            } else {
                this.elBtSniperProgramado.show();
            }
        }

        private limparInfoTentativasEcompras() {
            $('.tentativas').html('0');
            $('.quantidade-compras').html('0');
            $('.progress-compras').css('width', '0%');
        }

        public static getConteudoLogSniperIniciado(): string {
            return '<span class="badge badge-pill badge-primary text-uppercase">Sniper iniciado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Começou a snipar.</p>';
        }
        public static getConteudoLogSniperParado(): string {
            return '<span class="badge badge-pill badge-danger text-uppercase">Sniper parado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Parou de snipar.</p>';
        }
        public static salvarLogSnipouJogador(elementoLog: any, itemComprado: any) {
            var player = App.Util.getItemArrayById(App.Sniper.players, itemComprado.itemData.assetId, App.Sniper.objJogadorDefault);
            var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
            elementoLog.prepend('<span id="conteudoLogSnipou">\n\
                    <span class="badge badge-pill badge-success text-uppercase">Snipado</span>\n\
                    <span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span>\n\
                    <p class="description border-bottom">Você snipou <b>'+ nomeJogador + ' (' + itemComprado.itemData.rating + ')' + '</b> por <strong>' + itemComprado.buyNowPrice + ' coins</strong>.</p></span>');
        }
        public static getConteudoLogSnipou(itemComprado: any): string {
            return '<span id="conteudoLogSnipou">\n\
<span class="badge badge-pill badge-success text-uppercase">Snipado</span>\n\
<span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span>\n\
<p class="description border-bottom">Você snipou por <strong>' + itemComprado.buyNowPrice + ' coins</strong>.</p></span>';
        }
        public static getConteudoLogBloqueado(): string {
            return '<span class="badge badge-pill badge-danger text-uppercase">Bloqueado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description"><strong>Por segurança</strong> interrompemos o sniper, <strong>autenticação falhou</strong> ou seu mercado está bloqueado temporariamente.</p><a class="btn btn-1 btn-warning mt-1" href="' + App.Sniper.urlAppFut + '">Autenticar novamente</a><p class="border-bottom mt-0 height-10">&nbsp;</p>';
        }
        public static getConteudoLogLimiteCompraAtingido(valor: string | number): string {
            return '<span class="badge badge-pill badge-warning text-uppercase">Limite de compra atingido</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você atingiu o limite de compra de ' + valor + ' jogadore(s).</p>';
        }
        public static getConteudoLogLimiteTempoProgramado(): string {
            return '<span class="badge badge-pill badge-info text-uppercase">Tempo acabando</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Finalizando sniper programado.</p>';
        }
        public static salvarLogDisputaPerdida(elementoLog: any, item: any) {
            if (App.Sniper.ehConsumiveis) {
                elementoLog.prepend('<span class="badge badge-pill badge-default text-uppercase">Disputa perdida</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Disputa perdida pelo valor de <b>' + item.buyNowPrice + ' coins</b>, mas isso é comum, alguém conseguiu snipar antes que você.</p>');
            } else {
                var player = App.Util.getItemArrayById(App.Sniper.players, item.itemData.assetId, App.Sniper.objJogadorDefault);
                var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
                elementoLog.prepend('<span class="badge badge-pill badge-default">Disputa perdida</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Disputa perdida do jogador <b>' + nomeJogador + ' (' + item.itemData.rating + ')' + '</b> pelo valor de <b>' + item.buyNowPrice + ' coins</b>, mas isso é comum, alguém conseguiu snipar antes que você.</p>');

            }
        }
        public static salvarLogColocouaVenda(elementoLog: any, venda: any) {
            var player = App.Util.getItemArrayById(App.Sniper.players, venda.auctionInfo.itemData.assetId, App.Sniper.objJogadorDefault);
            var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
            elementoLog.prepend('<span class="badge badge-pill badge-info">Colocou à venda</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom"><b>' + nomeJogador + '</b> colocado à venda automaticamente por <b>' + venda.valorVenda.toString() + ' coins</b>.</p>');
        }

        public static getConteudoLogListaCheia(): string {
            return '<span class="badge badge-pill badge-danger text-uppercase">Venda bloqueada</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Algo deu errado, sua lista de transferência pode estar cheia.</p>';
        }
        public static getConteudoLogSemEspacoNasListas(): string {
            return '<span class="badge badge-pill badge-danger text-uppercase">Compra bloqueada</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Suas listas podem estar cheias, libere espaço e carregue as telas do Web App e Futsniperweb novamente.</p>';
        }
        public static getConteudoLogSemEspacoNaListaPorItensInegociaveis(): string {
            return '<span class="badge badge-pill badge-danger text-uppercase" style="color: #f89500;background-color: rgba(242, 252, 89, 0.5);">Sniper bloqueado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você precisa liberar itens inegociáveis que estão tomando conta do espaço em sua lista de itens não atribuídos.</p>';
        }
        public static getConteudoLogNaoColocadoAVenda(): string {
            return '<span class="badge badge-pill badge-danger text-uppercase">Venda bloqueada</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Suas listas podem estar cheias, libere espaço e carregue as telas do Web App e Futsniperweb novamente.</p>';
        }
        public static getConteudoLogMovidoParaTransferencia(quantidadeMovimentada: number): string {
            return '<span class="badge badge-pill badge-info text-uppercase">Espaço liberado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom"><b>' + quantidadeMovimentada + ' Item(s) movido(s)</b> para lista de transferência para liberar espaço na lista de itens não atribuídos.</p>';
        }
        public static getConteudoLogQuantidadeComprasDiariasAtingida(): string {
            return '<span class="badge badge-pill badge-warning text-uppercase">Limite compras/dia atingido</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você atingiu o limite diário de compras, aguarde o dia de amanhã para poder voltar a snipar ou adquira um plano melhor.</p>';
        }
        public static getConteudoLogTerminouComprasItensDme(): string {
            return '<span class="badge badge-pill badge-primary badge-comprou-itens-dme text-uppercase">Compra de elenco concluída</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você gastou <b>' + App.Sniper.totalGastoCompraDme + ' coins</b> na compra desse elenco de DME, os jogadores permanecem em suas listas de transferencias ou observação.</p>';
        }
        public static getConteudoLogCaptcha(): string {
            return '<span class="badge badge-pill badge-warning text-uppercase">Captcha</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você precisa resolver o captcha em sua conta.</p>';
        }
        public static salvarLogJogadorJaExiste(elementoLog: any, item: any) {
            var player = App.Util.getItemArrayById(App.Sniper.players, parseInt(item.assetId), App.Sniper.objJogadorDefault);
            var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
            elementoLog.prepend('<span class="badge badge-pill badge-info badge-jogador-existente">Jogador existente</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você já tem o jogador <b>' + nomeJogador + '</b> em seu clube.</p>');
        }
        public static salvarLogJogadorEspecialNaoCompramos(elementoLog: any, item: any) {
            var player = App.Util.getItemArrayById(App.Sniper.players, parseInt(item.assetId), App.Sniper.objJogadorDefault);
            var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
            elementoLog.prepend('<span class="badge badge-pill badge-info badge-jogador-especial">Jogador Especial</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">O Jogador <b>' + nomeJogador + '</b> desse elenco futbin é uma carta <b>especial ou de variação</b> do jogador, por segurança não podemos snipar cartas especiais para você, compre essa carta separadamente.</p>');
        }
        public static getConteudoLogListaDeJogadoresClubeAtualizada(): string {
            return '<span class="badge badge-pill badge-default badge-lista-jogadores-clube-atualizada text-uppercase">Jogadores Informados</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você informou os jogadores do seu clube, agora a ferramenta tem dados mais atualizados.</p>';
        }
        private temEspacoDisponivelNasListasDaEa(): boolean {
            return (App.Sniper.quantidadeDisponivelListaDeObservacao + App.Sniper.quantidadeDisponivelListaDeTransferencia) > 0;
        }

        private getChromeVersion(): number | any {
            var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

            return raw ? parseInt(raw[2], 10) : false;
        }

        private validarPlano(e: JQueryEventObject | any) {
            if (e) {
                e.preventDefault();
            }

            $.ajax({
                url: App.Util.config.urlStatus,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        dados_ea: App.Sniper.dadosContaEa,
                        nome_conta_ea: App.Sniper.dadosContaEa.clube,
                        quantidade_max_compras_por_vez: App.Sniper.getQuantidadeMaxCompras(),
                        velocidade_max: this.getMilesegundos(),
                        tempo_max_programado: App.Sniper.getTempoProgramadoSniper(),
                        id_liga: App.Util.empty($('#liga').val()) ? 0 : parseInt($('#liga').val()),
                        nome_liga: App.Util.empty($('.conferencia-liga span').html()) ? null : $('.conferencia-liga span').html()
                    }),
                beforeSend: function(jqXHR, settings) {
                    jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
                },
                success: (resposta) => {
                    if (!App.Sniper.ehAnaliseClube) {
                        App.Util.ocultarModalPaginaCarregando();
                    }
                    if (resposta.status && !e) {
                        return;
                    } else if (resposta.status) {
                        this.aoSnipar(e);
                    } else {
                        this.exibirMensagemAlertaSwal(resposta.tituloMensagem, resposta.mensagem, resposta.tipo, resposta.textoBotaoConfirma, resposta.textoBotaoCancela, '#2dce89', resposta.exibirBotaoCancelar, resposta.urlRedirecionamentoBotaoConfirma, null, resposta.contaEaJaVinculada);
                    }
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    if (!App.Sniper.ehAnaliseClube) {
                        App.Util.ocultarModalPaginaCarregando();
                    }
                }
            });

        }
        private aoSnipar(e: JQueryEventObject) {
            this.inicializarConfiguracoes();
            if (App.Sniper.ehVersaoDesatualizadaExtensao()) {
                this.exibirMensagemExtensaoDesatualizada();
                return;
            } else if (App.Sniper.sniperTravado) {
                App.Sniper.exibirMensagemSnipeTravado();
                return;
            } else if (App.Sniper.listaNaoAtribuidosBloqueada) {
                this.exibirMensagemItensInegociaveisOcupandoLista();
                return;
            } else if (!this.temEspacoDisponivelNasListasDaEa()) {
                this.exibirMensagemSemCapacidadeNasListasDeTranferencia();
                return;
            } else {
                if (!App.Sniper.ehConsumiveis && !App.Sniper.ehJogadorEspecial && App.Util.ehCampoTextoVazio(this.elCampoQualidade) && App.Util.ehCampoTextoVazio(this.elCampoRaridade) && App.Util.ehCampoTextoVazio(this.elCampoPosicao) && App.Util.ehCampoTextoVazio(this.elCampoEstilo) && App.Util.ehCampoTextoVazio(this.elCampoJogador) && App.Util.ehCampoTextoVazio(this.elCampoClube) && App.Util.ehCampoTextoVazio(this.elCampoLiga) && App.Util.ehCampoTextoVazio(this.elCampoNacionalidade)) {
                    swal("Obrigatório!", "Informe pelo menos um filtro para iniciar o sniper.", "error");
                    return;
                }
                // Validação para venda automática ativa
                if (this.elAtivarVendaAutomatica.is(':checked') && this.modoManterNoCemiterio()) {
                    swal("Obrigatório!", "Atualmente a venda automática só funciona quando os ítens são enviados para lista de transferência.", "error");
                    return;
                }
                if (App.Sniper.ehJogadorEspecial && !this.modoHumanoAtivo()) {
                    swal("Obrigatório!", "Atualmente a busca por jogador especial só funciona quando os ítens são enviados para lista de transferência.", "error");
                    return;
                }
                if (App.Sniper.ehJogadorEspecial && App.Util.ehCampoTextoVazio(this.elCampoJogador)) {
                    swal("Obrigatório!", "Informe o jogador especial", "error");
                    return;
                }
                // Validação para valor máximo
                if (App.Util.ehCampoTextoVazio(this.elCampoValorMaximo)) {
                    swal("Obrigatório!", "Informe o valor de oferta", "error");
                    return;
                }

                toastr.success("Fique tranquilo, o sistema fará tudo automático para você.", "Sniper iniciado!");
                $("#espacoLogs").prepend(App.Sniper.getConteudoLogSniperIniciado());

                //Se sniper foi programado
                App.Sniper.sniperProgramado = App.Sniper.tempoProgramado > 0;
                if (App.Sniper.sniperProgramado) {
                    console.log("sniperProgramado", App.Sniper.tempoIntervaloEntreTentativas);
                    App.Sniper.finalizarLoopIntervalo();
                    var acrecimoTentativas: number = this.modoHumanoAtivo() ? this.tempoAcrescimoTentativa : 0;
                    var segundosTotaisCicloDasTentativas = App.Util.parseMilisegundosParaSegundos(this.getMilesegundos() + acrecimoTentativas) * App.Sniper.getQuantidadeMaxTentativasPorVez();
                    if (this.modoCompraElencoDme) {
                        //Aleatório entre 30 segundo e 1 min
                        var milisegundosDescanso = App.Util.getRandomInt(30000, 60000) + App.Util.parseSegundosParaMilisegundos(segundosTotaisCicloDasTentativas);
                    } else if (this.modoHumanoAtivo()) {
                        //Aleatório dependendo da escolha do usuário
                        var milisegundosDescanso = this.obterTempoDescansoAleatorioPorOpcaoEscolhida(App.Sniper.tempoIntervaloEntreTentativas) + App.Util.parseSegundosParaMilisegundos(segundosTotaisCicloDasTentativas);
                        console.log("OPCAO ESCOLHIDA::", App.Sniper.tempoIntervaloEntreTentativas);
                        console.log("TEMPO DE DESCANSO::", milisegundosDescanso);
                        console.log("TEMPO DE DESCANSO REAL::", (milisegundosDescanso - App.Util.parseSegundosParaMilisegundos(segundosTotaisCicloDasTentativas)));
                    } else if (App.Sniper.tempoIntervaloEntreTentativas > 0) {
                        var milisegundosDescanso = App.Util.parseMinutosParaMilisegundos(App.Sniper.tempoIntervaloEntreTentativas) + App.Util.parseSegundosParaMilisegundos(segundosTotaisCicloDasTentativas);
                    } else {
                        var milisegundosDescanso = 30000 + App.Util.parseSegundosParaMilisegundos(segundosTotaisCicloDasTentativas);
                    }

                    //Aqui onde inicio as tentativas com intervalo de descanso
                    App.Sniper.loopIntervaloProgramado = setInterval(() => this.snipar(e, true), milisegundosDescanso);

                    App.Sniper.arrayLoopIntervalos.push(App.Sniper.loopIntervaloProgramado);
                    App.Sniper.tempoParaFinalizarLoopProgramado = setTimeout(() => { App.Sniper.finalizarSniperProgramado(); }, App.Util.parseMinutosParaMilisegundos(App.Sniper.tempoProgramado));
                    App.Sniper.iniciarCronometro(App.Sniper.tempoProgramado * 60);
                }

                if (App.Sniper.ehConsumiveis) {
                    this.objFiltro = this.getObjetoFiltrosConsumiveis(e);
                } else if (App.Sniper.ehJogadorEspecial) {
                    App.Sniper.passoPagina = null;
                    if (this.modoPotenteDeBuscaDeJogadorEspecial()) {
                        this.objFiltro = this.getObjetoFiltrosJogadorEspecialForcado(e);
                    } else {
                        this.objFiltro = this.getObjetoFiltrosJogadorEspecial(e);
                    }
                } else {
                    this.objFiltro = this.getObjetoFiltros(e);
                }
                App.Sniper.errorsCompraSequencia = 0;
                $('#abaLog').click();
                this.fecharWebApp();
                this.snipar(e);
            }
        }

        private obterTempoDescansoAleatorioPorOpcaoEscolhida(opcaoEscolhida: number | string) {
            switch (opcaoEscolhida) {
                case 0:
                    return App.Util.getRandomInt(30000, 60000);
                case 1:
                    return App.Util.getRandomInt(30000, 120000);
                case 2:
                    return App.Util.getRandomInt(60000, 120000);
                case 3:
                    return App.Util.getRandomInt(60000, 180000);
                case 4:
                    return App.Util.getRandomInt(120000, 240000);
                default:
                    return App.Util.getRandomInt(30000, 120000);
            }

        }
        private fecharWebApp() {
            if (this.modoHumanoAtivo()) {
                chrome.runtime.sendMessage(this.idExtensao, { evento: "fchwpp" }, (resposta: any) => { });
            }
        }

        private snipar(e: JQueryEventObject, tentativaProgramada = false, teste = false) {
            if (teste) {
                App.Sniper.quantidadeMaximaTentativasPorVez = 1;
                this.objFiltro = this.getObjetoFiltrosTeste(e);
            }

            App.Sniper.itensExpiradosOuComprados = [];
            if (!this.temEspacoDisponivelNasListasDaEa()) {
                $("#espacoLogs").prepend(App.Sniper.getConteudoLogSemEspacoNasListas());
                this.pararTudo();
                return;
            }

            if (this.getQuantidadeCompras() >= App.Sniper.quantidadeMaximaCompras) {
                this.pararTudo();
                return;
            }

            $('.tentativas').html('0');
            if (!tentativaProgramada) {
                $(".loading").show();
                App.Sniper.sniperAtivo = true;
                App.Sniper.acionadoPeloUsuario = false;
                App.Sniper.elBtSnipar.prop('disabled', true);
                App.Sniper.exibirLoadingSniperApp();
            }
            var acrecimoTentativas: number = this.modoHumanoAtivo() ? this.tempoAcrescimoTentativa : 0;
            App.Sniper.finalizarTentativasSniper();
            App.Sniper.descansoDeCompra = 0;
            console.log("INICIOU TENTATIVAS::", new Date().toLocaleString())
            App.Sniper.loopTentativas = setInterval(() => {
                if (App.Sniper.movimentandoItens) {
                    return;
                }

                var comprasNoLimite = this.getQuantidadeCompras() >= App.Sniper.quantidadeMaximaCompras;
                var tentativasNoLimite = this.getQuantidadeTentativas() >= App.Sniper.quantidadeMaximaTentativasPorVez;
                if (!App.Sniper.sniperAtivo || comprasNoLimite || tentativasNoLimite) {
                    if (comprasNoLimite) {
                        if (!App.Sniper.acionadoPeloUsuario) {
                            $("#espacoLogs").prepend(App.Sniper.getConteudoLogLimiteCompraAtingido(App.Sniper.quantidadeMaximaCompras));
                        }
                        this.pararTudo();
                    }

                    if (!App.Sniper.sniperProgramado) {
                        App.Sniper.habilitarPossibilidadeDeSnipar();
                        if (!comprasNoLimite) {
                            $("#espacoLogs").prepend(App.Sniper.getConteudoLogSniperParado());
                        }
                    }

                    if (!App.Sniper.sniperAtivo) {
                        if (App.Sniper.sniperProgramado) {
                            App.Sniper.habilitarPossibilidadeDeSnipar();
                            App.Sniper.finalizarSniperProgramado(!App.Sniper.acionadoPeloUsuario);
                        }
                        console.log("TERMINOU TENTATIVAS::", new Date().toLocaleString())
                        App.Sniper.finalizarTentativasSniper();
                    }

                    if (tentativasNoLimite) {
                        console.log("TERMINOU TENTATIVAS::", new Date().toLocaleString())
                        App.Sniper.finalizarTentativasSniper();
                        if (this.modoCompraElencoDme) {
                            var indexItemElencoDme = App.Util.getIndiceArrayByAssetId(App.Util.elencoDme.elenco, this.objFiltro.maskedDefId);
                            App.Util.elencoDme.elenco[indexItemElencoDme].preco = App.Util.incrementarValorDeFiltro(App.Util.elencoDme.elenco[indexItemElencoDme].preco);
                            this.exibirDetalhesLoadJogador(App.Util.elencoDme.elenco[indexItemElencoDme]);
                        }
                    }

                    if (!App.Sniper.sniperProgramado) {
                        App.Sniper.sniperAtivo = false;
                    }

                    clearInterval(App.Sniper.loopTentativas);
                    App.Sniper.elSpinnerCancelar.hide();
                    App.Sniper.acionadoPeloUsuario = false;
                    return;
                }
                if (!teste) {
                    this.atualizarFiltro();
                }
                this.processarTentativa(e, teste);
                App.Sniper.acionadoPeloUsuario = false;
            }, App.Util.getRandomInt(this.getMilesegundos(), this.getMilesegundos() + acrecimoTentativas));


            App.Sniper.arrayLoopTentativas.push(App.Sniper.loopTentativas);
            // Atualizando loop com novo intervalo de descanso caso esteja no modo humano
            this.atualizarDescansoTentativaModoAleatorio(e, tentativaProgramada);
        }


        private atualizarDescansoTentativaModoAleatorio(e: JQueryEventObject, tentativaProgramada: boolean) {
            if (this.modoHumanoAtivo() && tentativaProgramada) {
                clearInterval(App.Sniper.loopIntervaloProgramado);
                var acrecimoTentativas: number = this.modoHumanoAtivo() ? this.tempoAcrescimoTentativa : 0;
                var segundosTotaisCicloDasTentativas = App.Util.parseMilisegundosParaSegundos(this.getMilesegundos() + acrecimoTentativas) * App.Sniper.getQuantidadeMaxTentativasPorVez();
                var novoTempo = this.obterTempoDescansoAleatorioPorOpcaoEscolhida(App.Sniper.tempoIntervaloEntreTentativas) + App.Util.parseSegundosParaMilisegundos(segundosTotaisCicloDasTentativas);
                console.log("NOVO TEMPO DE DESCANSO::", novoTempo)
                console.log("NOVO TEMPO DE DESCANSO REAL::", (novoTempo - App.Util.parseSegundosParaMilisegundos(segundosTotaisCicloDasTentativas)));
                App.Sniper.loopIntervaloProgramado = setInterval(() => this.snipar(e, true), novoTempo);
            }
        }

        private atualizarFiltro() {
            if (App.Sniper.ehJogadorEspecial && !this.modoPotenteDeBuscaDeJogadorEspecial()) {
                this.objFiltro.start = App.Sniper.passoPagina ? (App.Sniper.passoPagina == ">" ? (this.objFiltro.start + 20) * App.Sniper.indiceQuantidadePaginas : (App.Sniper.passoPagina == "<" ? (this.objFiltro.start >= 20 ? this.objFiltro.start - 20 : this.objFiltro.start) : this.objFiltro.start)) : 0;
            } else {
                App.Sniper.valorMinimo = this.variarFiltroAvancado(App.Sniper.valorMinimo);
                this.elCampoMinimo.val(App.Sniper.valorMinimo);
                if (this.modoCompraElencoDme) {
                    var itemElencoDme: IElencoDme = App.Util.getItemArrayByAssetId(App.Util.elencoDme.elenco, this.objFiltro.maskedDefId);
                    if (App.Util.empty(itemElencoDme.preco) || itemElencoDme.preco <= 0) {
                        itemElencoDme.preco = itemElencoDme.precoMin < 200 ? 200 : itemElencoDme.precoMin;
                        itemElencoDme.precoInicial = itemElencoDme.preco;
                    } else if (itemElencoDme.porcentagemMaisBarato > 0 && itemElencoDme.preco > 200) {
                        if (App.Util.empty(itemElencoDme.precoInicial)) {
                            itemElencoDme.preco = this.obterValorMaisBaratoPorPorcentagem(itemElencoDme, itemElencoDme.porcentagemMaisBarato);
                            itemElencoDme.precoInicial = itemElencoDme.preco;
                        }
                    }
                    itemElencoDme.precoInicial = itemElencoDme.hasOwnProperty("precoInicial") ? itemElencoDme.precoInicial : itemElencoDme.preco
                    this.exibirDetalhesLoadJogador(itemElencoDme);
                    this.objFiltro.maxb = itemElencoDme.preco <= itemElencoDme.precoMax ? itemElencoDme.preco : itemElencoDme.precoMin;
                } else {
                    this.objFiltro.maxb = App.Util.getRandomInt(1, 5) == 3 && App.Sniper.maxbInicial > 200 ? App.Util.decrementarValorDeFiltro(App.Sniper.maxbInicial) : App.Sniper.maxbInicial;
                }

                /**
                 * Variando para nao ter valor lance minimo as vezes
                 */
                if (App.Util.getRandomInt(1, 12) == 3 && this.objFiltro.maxb <= 20000) {
                    delete this.objFiltro.micr;
                } else {
                    this.objFiltro.micr = App.Sniper.valorMinimo;
                }


                /**
                 * Variando para ter valor lance maximo as vezes
                 */
                //                var decrementValoMaxb = App.Util.decrementarValorDeFiltro(this.objFiltro.maxb);
                //                if (App.Sniper.valorMinimo >= decrementValoMaxb) {
                //                    delete this.objFiltro.macr;
                //                } else if (App.Util.getRandomInt(1, 10) == 3 && this.objFiltro.maxb <= 20000) {
                //                    this.objFiltro.macr = decrementValoMaxb;
                //                } else if (App.Util.getRandomInt(1, 20) == 3) {
                //                    this.objFiltro.macr = decrementValoMaxb;
                //                } else {
                //                    delete this.objFiltro.macr;
                //                }

                if (App.Sniper.ehPadrao && this.dadosForm.hasOwnProperty("jogador") && this.dadosForm.jogador.length > 0) {
                    if (this.modoCompraElencoDme) {
                        this.objFiltro.maskedDefId = this.dadosForm.jogador[0];
                    } else {
                        this.objFiltro.maskedDefId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
                    }
                }
            }

            if (App.Sniper.ehPadrao) {
                this.objFiltro = this.ordenarObjetoFiltros(this.objFiltro);
            }

            if (App.Sniper.ehConsumiveis) {
                this.objFiltro = this.ordenarObjetoFiltrosConsumiveis(this.objFiltro);
            }
        }

        public obterValorMaisBaratoPorPorcentagem(itemElencoDme: IElencoDme, iPorcentagem: number) {
            var precoFinal = itemElencoDme.preco;
            var precoMaisBarato = itemElencoDme.preco - ((iPorcentagem / 100) * itemElencoDme.preco);
            if (precoMaisBarato >= 200 && precoMaisBarato <= itemElencoDme.precoMax) {
                precoFinal = App.Util.tratarValorDeFiltro(precoMaisBarato);
            }
            return precoFinal;
        }

        public static processarTrava() {
            this.runAudio(2);
            App.Sniper.sniperTravado = 1;
            $("#espacoLogs").prepend(App.Sniper.getConteudoLogBloqueado());
        }

        private getObjetoFiltrosJogadorEspecial(e: JQueryEventObject): IFiltro {
            this.ajax = new App.Ajax();
            this.dadosForm = this.ajax.convertFormToJSON($(e.target));
            App.Sniper.maxbInicial = App.Util.ehVariavelValidaNaoVazia(this.dadosForm.max) ? this.dadosForm.max : 200;
            var filtro: IFiltro = {
                start: 0,
                num: 21,
                type: "player"
            }
            if (this.dadosForm.hasOwnProperty("jogador") && this.dadosForm.jogador.length > 0) {
                filtro.definitionId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
            } else {
                swal("Erro!", "Um erro ocorreu, por segurança a página será recarregada", "error");
                setTimeout(() => {
                    document.location.reload(true);
                }, 4000);
                return;
            }

            return filtro;
        }

        private getObjetoFiltrosJogadorEspecialForcado(e: JQueryEventObject): IFiltro {
            this.ajax = new App.Ajax();
            this.dadosForm = this.ajax.convertFormToJSON($(e.target));
            App.Sniper.maxbInicial = this.dadosForm.hasOwnProperty("max") && App.Util.ehVariavelValidaNaoVazia(this.dadosForm.max) ? this.dadosForm.max : 200;
            var filtro: IFiltro = {
                start: 0,
                num: 21,
                type: "player",
                micr: App.Sniper.valorMinimo,
                maxb: App.Sniper.maxbInicial
            }
            if (this.dadosForm.hasOwnProperty("jogador") && this.dadosForm.jogador.length > 0) {
                filtro.definitionId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
            } else {
                swal("Erro!", "Um erro ocorreu, por segurança a página será recarregada", "error");
                setTimeout(() => {
                    document.location.reload(true);
                }, 4000);
                return;
            }

            return filtro;
        }

        private ordenarObjetoFiltros(filtroAtual: IFiltro): IFiltro {
            var filtroOrdenado: IFiltro = {
                num: 21,
                start: 0,
                type: "player"
            }

            if (filtroAtual.hasOwnProperty("maskedDefId")) {
                filtroOrdenado.maskedDefId = filtroAtual.maskedDefId;
            }
            if (filtroAtual.hasOwnProperty("zone")) {
                filtroOrdenado.zone = filtroAtual.zone;
            }
            if (filtroAtual.hasOwnProperty("pos")) {
                filtroOrdenado.pos = filtroAtual.pos;
            }
            if (filtroAtual.hasOwnProperty("rare")) {
                filtroOrdenado.rare = filtroAtual.rare;
            }
            if (filtroAtual.hasOwnProperty("lev")) {
                filtroOrdenado.lev = filtroAtual.lev;
            }
            if (filtroAtual.hasOwnProperty("nat")) {
                filtroOrdenado.nat = filtroAtual.nat;
            }
            if (filtroAtual.hasOwnProperty("leag")) {
                filtroOrdenado.leag = filtroAtual.leag;
            }
            if (filtroAtual.hasOwnProperty("team")) {
                filtroOrdenado.team = filtroAtual.team;
            }
            if (filtroAtual.hasOwnProperty("playStyle")) {
                filtroOrdenado.playStyle = filtroAtual.playStyle;
            }
            if (filtroAtual.hasOwnProperty("micr")) {
                filtroOrdenado.micr = filtroAtual.micr;
            }
            if (filtroAtual.hasOwnProperty("macr")) {
                filtroOrdenado.macr = filtroAtual.macr;
            }
            if (filtroAtual.hasOwnProperty("minb")) {
                filtroOrdenado.minb = filtroAtual.minb;
            }
            if (filtroAtual.hasOwnProperty("maxb")) {
                filtroOrdenado.maxb = filtroAtual.maxb;
            }
            if (filtroAtual.hasOwnProperty("rarityIds")) {
                filtroOrdenado.rarityIds = filtroAtual.rarityIds;
            }

            return filtroOrdenado;
        }
        private ordenarObjetoFiltrosConsumiveis(filtroAtual: IFiltroConsumivel): IFiltro {
            var filtroOrdenado: IFiltroConsumivel = {
                num: 21,
                start: 0,
                type: "training"
            }

            if (filtroAtual.hasOwnProperty("type")) {
                filtroOrdenado.type = filtroAtual.type;
            }

            if (filtroAtual.hasOwnProperty("cat")) {
                filtroOrdenado.cat = filtroAtual.cat;
            }

            if (filtroAtual.hasOwnProperty("pos")) {
                filtroOrdenado.pos = filtroAtual.pos;
            }

            if (filtroAtual.hasOwnProperty("lev")) {
                filtroOrdenado.lev = filtroAtual.lev;
            }

            if (filtroAtual.hasOwnProperty("playStyle")) {
                filtroOrdenado.playStyle = filtroAtual.playStyle;
            }
            if (filtroAtual.hasOwnProperty("micr")) {
                filtroOrdenado.micr = filtroAtual.micr;
            }
            if (filtroAtual.hasOwnProperty("macr")) {
                filtroOrdenado.macr = filtroAtual.macr;
            }
            if (filtroAtual.hasOwnProperty("minb")) {
                filtroOrdenado.minb = filtroAtual.minb;
            }
            if (filtroAtual.hasOwnProperty("maxb")) {
                filtroOrdenado.maxb = filtroAtual.maxb;
            }

            return filtroOrdenado;
        }

        private getObjetoFiltros(e: JQueryEventObject): IFiltro {
            this.ajax = new App.Ajax();
            this.dadosForm = this.ajax.convertFormToJSON($(e.target));
            App.Sniper.maxbInicial = this.dadosForm.hasOwnProperty("max") && App.Util.ehVariavelValidaNaoVazia(this.dadosForm.max) ? this.dadosForm.max : 200;

            var filtro: IFiltro = {
                num: 21,
                start: 0,
                type: "player"
            }

            if (this.dadosForm.hasOwnProperty("jogador") && this.dadosForm.jogador.length > 0) {
                if (this.modoCompraElencoDme) {
                    filtro.maskedDefId = this.dadosForm.jogador[0];
                } else {
                    filtro.maskedDefId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
                }
            }

            if (this.dadosForm.hasOwnProperty('posicao') && this.dadosForm.posicao) {
                if (this.dadosForm.posicao == 'defense' || this.dadosForm.posicao == 'midfield' || this.dadosForm.posicao == 'attacker') {
                    filtro.zone = this.dadosForm.posicao;
                } else {
                    filtro.pos = this.dadosForm.posicao;
                }
            }

            if (this.dadosForm.hasOwnProperty("qualidade") && this.dadosForm.qualidade) {
                if (this.dadosForm.qualidade == 'SP') {
                    filtro.rare = this.dadosForm.qualidade;
                } else {
                    filtro.lev = this.dadosForm.qualidade;
                }
            }

            if (this.dadosForm.hasOwnProperty("pais") && this.dadosForm.pais) {
                filtro.nat = this.dadosForm.pais;
            }
            if (this.dadosForm.hasOwnProperty("liga") && this.dadosForm.liga) {
                filtro.leag = this.dadosForm.liga;
            }
            if (this.dadosForm.hasOwnProperty("time") && this.dadosForm.time) {
                filtro.team = this.dadosForm.time;
            }
            if (this.dadosForm.hasOwnProperty("estilo") && this.dadosForm.estilo) {
                filtro.playStyle = this.dadosForm.estilo;
            }

            //            filtro.micr = App.Sniper.valorMinimo;

            if (this.dadosForm.hasOwnProperty("min") && this.dadosForm.min) {
                filtro.minb = this.dadosForm.min;
            }

            filtro.maxb = App.Sniper.maxbInicial;

            if (this.dadosForm.hasOwnProperty("raridade") && this.dadosForm.raridade) {
                filtro.rarityIds = this.dadosForm.raridade;
            }

            return filtro;
        }
        private getObjetoFiltrosTeste(e: JQueryEventObject): IFiltro {
            var filtro: IFiltro = {
                start: 0,
                num: 21,
                type: "player",
                maxb: 200
            }

            return filtro;
        }


        private getObjetoFiltrosConsumiveis(e: JQueryEventObject): IFiltro {
            this.ajax = new App.Ajax();
            this.dadosForm = this.ajax.convertFormToJSON($(e.target));
            App.Sniper.maxbInicial = this.dadosForm.hasOwnProperty("max") && App.Util.ehVariavelValidaNaoVazia(this.dadosForm.max) ? this.dadosForm.max : 200;
            var filtro: IFiltroConsumivel = {
                num: 21,
                start: 0,
                type: "training"
            }

            if (this.dadosForm.hasOwnProperty("tipo") && this.dadosForm.tipo) {
                filtro.type = this.dadosForm.tipo;
            }
            if (this.dadosForm.hasOwnProperty("categoria") && this.dadosForm.categoria && !this.dadosForm.hasOwnProperty("tipo")) {
                filtro.cat = this.dadosForm.categoria;
                if (this.dadosForm.categoria == "position" && this.dadosForm.troca_posicao != "") {
                    filtro.pos = this.dadosForm.troca_posicao;
                }
            }
            if (this.dadosForm.hasOwnProperty("qualidade") && this.dadosForm.qualidade) {
                filtro.lev = this.dadosForm.qualidade;
            }
            if (this.dadosForm.hasOwnProperty("estilo") && this.dadosForm.estilo) {
                filtro.playStyle = this.dadosForm.estilo;
            }
            if (this.dadosForm.hasOwnProperty("definitionId") && this.dadosForm.definitionId) {
                filtro.definitionId = this.dadosForm.definitionId;
            }

            //            filtro.micr = App.Sniper.valorMinimo;

            if (this.dadosForm.hasOwnProperty("min") && this.dadosForm.min) {
                filtro.minb = this.dadosForm.min;
            }

            filtro.maxb = App.Sniper.maxbInicial;

            return filtro;
        }

        private getObjetoFiltroTransferenciaCoins(item: IItemTransferenciaCoins): IFiltro {
            this.ajax = new App.Ajax();

            let filtro: IFiltro = {
                start: 0,
                num: 21,
                type: "player",
                maskedDefId: item.assetID,
                pos: item.position,
                micr: item.startPrice,
                macr: App.Util.incrementarValorDeFiltro(item.startPrice),
                maxb: item.buyNowPrice
            }


            return filtro;
        }

        /**
         * liberar a lista conhecida como cemitério ou limbo
         */
        private liberarListaDeObservacao(): any {
            if (App.Sniper.quantidadeDisponivelListaDeTransferencia <= 0) {
                return;
            }

            App.Sniper.movimentandoItens = true;
            App.Sniper.finalizarLoopLimpezaListaObsSniper();
            var erro503 = 0;
            var erroItemInegociavel = 0;
            var erroVenda = 0;
            this.registrarEvento(App.Sniper.eventoAppHome, 'view_home_app');
            // liberarListaDeObservacao pela extensão
            var quantidadeMovimentada = 0;
            chrome.runtime.sendMessage(this.idExtensao, { evento: "chlt" },
                (resultado: any) => {
                    var i = 0;
                    if (resultado.quantidade > 0) {
                        var loopLimpezaListaObs = setInterval(() => {
                            if (i >= resultado.quantidade || App.Sniper.quantidadeDisponivelListaDeTransferencia <= 0) {
                                this.registrarEvento(App.Sniper.eventoAppTelaTransferencia, 'view_transfer_app');
                                App.Sniper.movimentandoItens = false;
                                this.processarMovimentoDeLista(quantidadeMovimentada);
                                clearInterval(loopLimpezaListaObs);
                                App.Sniper.finalizarLoopLimpezaListaObsSniper();
                                return false;
                            }
                            var indexVenda = App.Sniper.arrayItensVendaAutomatica.findIndex((item: any) => item.auctionInfo.itemData.id == resultado.response.itemData[i].id);
                            chrome.runtime.sendMessage(this.idExtensao, { evento: "lct", item: resultado.response.itemData[i], venda: (indexVenda >= 0 ? App.Sniper.arrayItensVendaAutomatica[indexVenda] : null), indexVenda: (indexVenda >= 0 ? indexVenda : null) },
                                (resultadoTransferencia: any) => {
                                    switch (resultadoTransferencia.tipo) {
                                        case "transferencia":
                                            if (resultadoTransferencia.status) {
                                                quantidadeMovimentada++;
                                                this.incrementarQuantidadeDisponivelListaDeObservacao();
                                                this.decrementarQuantidadeDisponivelListaDeTransferencia();
                                                if (resultadoTransferencia.colocadoNaVenda) {
                                                    this.finalizarListagemNaVendaAutomatica(resultadoTransferencia.venda, resultadoTransferencia.indexVenda);
                                                }
                                            } else {
                                                //Se nao transferiu
                                                $("#espacoLogs").prepend(App.Sniper.getConteudoLogSemEspacoNasListas());
                                                this.processarMovimentoDeLista(quantidadeMovimentada);
                                                if (App.Sniper.quantidadeDisponivelListaDeTransferencia <= 0) {
                                                    this.pararTudo(true);
                                                }
                                                clearInterval(loopLimpezaListaObs);
                                                App.Sniper.finalizarLoopLimpezaListaObsSniper();
                                                return false;
                                            }
                                            break;
                                        case "erro_transferencia":
                                            if (resultadoTransferencia.response.status == 503) {
                                                erro503++;
                                            }
                                            //Se nao transferiu
                                            if (erro503 >= 5) {
                                                $("#espacoLogs").prepend(App.Sniper.getConteudoLogSemEspacoNasListas());
                                                this.pararTudo(true);
                                                clearInterval(loopLimpezaListaObs);
                                                App.Sniper.finalizarLoopLimpezaListaObsSniper();
                                                return false;
                                            }

                                            if (App.Util.inArray(resultadoTransferencia.response.status, [401, 403, 458])) {
                                                $("#espacoLogs").prepend(App.Sniper.getConteudoLogBloqueado());
                                                this.pararTudo(true);
                                                clearInterval(loopLimpezaListaObs);
                                                App.Sniper.finalizarLoopLimpezaListaObsSniper();
                                                if (resultadoTransferencia.response.status == 458) {
                                                    $("#espacoLogs").prepend(App.Sniper.getConteudoLogCaptcha());
                                                }
                                                return false;
                                            }
                                            break;
                                        case "erro_transferencia_item_inegociavel":
                                            erroItemInegociavel++;
                                            //Se nao transferiu
                                            if (erroItemInegociavel >= App.Sniper.capacidadeHumanaListaDeObservacao) {
                                                App.Sniper.listaNaoAtribuidosBloqueada = true;
                                                this.exibirMensagemItensInegociaveisOcupandoLista();
                                                $("#espacoLogs").prepend(App.Sniper.getConteudoLogSemEspacoNaListaPorItensInegociaveis());
                                                this.pararTudo(true);
                                                clearInterval(loopLimpezaListaObs);
                                                App.Sniper.finalizarLoopLimpezaListaObsSniper();
                                                return false;
                                            }
                                            break;
                                        case "erro_venda":
                                            erroVenda++;

                                            //Se nao está colocando a venda
                                            if (erroVenda >= 5) {
                                                $("#espacoLogs").prepend(App.Sniper.getConteudoLogNaoColocadoAVenda());
                                                this.pararTudo(true);
                                                clearInterval(loopLimpezaListaObs);
                                                App.Sniper.finalizarLoopLimpezaListaObsSniper();
                                                return false;
                                            }

                                            if (App.Util.inArray(resultadoTransferencia.response.status, [401, 403, 458])) {
                                                $("#espacoLogs").prepend(App.Sniper.getConteudoLogBloqueado());
                                                this.pararTudo(true);
                                                clearInterval(loopLimpezaListaObs);
                                                App.Sniper.finalizarLoopLimpezaListaObsSniper();
                                                if (resultadoTransferencia.response.status == 458) {
                                                    $("#espacoLogs").prepend(App.Sniper.getConteudoLogCaptcha());
                                                }
                                                return false;
                                            }
                                            break;
                                    }
                                });
                            i++;
                        }, 3000);
                        App.Sniper.arrayLoopLimpezaListaObs.push(loopLimpezaListaObs);
                    } else {
                        App.Sniper.movimentandoItens = false;
                    }
                });
        }

        private finalizarListagemNaVendaAutomatica(venda: any, indexVenda: any) {
            App.Sniper.arrayItensVendaAutomatica.splice(indexVenda, 1);
            App.Sniper.salvarLogColocouaVenda($("#espacoLogs"), venda);
        }
        private processarMovimentoDeLista(quantidadeMovimentada: number) {
            var i = 0;
            if (quantidadeMovimentada) {
                $("#espacoLogs").prepend(App.Sniper.getConteudoLogMovidoParaTransferencia(quantidadeMovimentada));
            }
        }

        private processarTentativa(e: JQueryEventObject, teste: boolean = false): any {
            if (!this.temEspacoDisponivelNasListasDaEa()) {
                $("#espacoLogs").prepend(App.Sniper.getConteudoLogSemEspacoNasListas());
                this.pararTudo();
                return;
            }

            this.addQuantidadeTentativas();

            /**
             * Se ainda tiver na tentativa anterior
             */
            if (App.Sniper.tentando) {
                App.Sniper.tentando = false;
                return;
            }

            /**
             * Se é pra descançar após uma compra
             */
            if (App.Sniper.descansoDeCompra > 0) {
                console.log("descancando", App.Sniper.descansoDeCompra);
                App.Sniper.descansoDeCompra--;
                return;
            }


            // Snipando pela extensão
            App.Sniper.tentando = true;
            var rand = Math.floor(Math.random() * (0 - 2000 + 1) + 2000);
            setTimeout(() => {
                chrome.runtime.sendMessage(this.idExtensao, { evento: this.modoHumanoAtivo() ? "sprsec" : "spr", dados: this.objFiltro, dadosEa: App.Sniper.dadosContaEa, itensExpiradosOuComprados: App.Sniper.itensExpiradosOuComprados, quantidadeLimiteCompraAtual: (App.Sniper.quantidadeMaximaCompras - this.getQuantidadeCompras()), passoPagina: App.Sniper.passoPagina, indiceQuantidadePaginas: App.Sniper.indiceQuantidadePaginas, ofertaCompra: App.Sniper.maxbInicial },
                    (resultado: any) => {
                        if (App.Sniper.itensExpiradosOuComprados.length >= 10) {
                            App.Sniper.itensExpiradosOuComprados = [];
                        }
                        switch (resultado.tipo) {
                            case "busca":
                                //Se buscou corretamente
                                if (resultado.status) {
                                    App.Sniper.errorsSequencia = 0;
                                } else {
                                    App.Sniper.errorsSequencia++;
                                    if (!teste && App.Sniper.errorsSequencia <= 2 && !App.Util.inArray(resultado.response.status, [401, 403, 458])) {
                                        return;
                                    }
                                    App.Sniper.processarTrava();
                                    if (!teste) {
                                        App.Sniper.exibirMensagemSnipeTravado();
                                    }

                                    this.pararTudo();

                                    /**
                                     * Se for um pedido de captcha da EA
                                     */
                                    if (resultado.response.status == 458) {
                                        $("#espacoLogs").prepend(App.Sniper.getConteudoLogCaptcha());
                                        var dados: any = { id: App.Util.usuario.id, nome_conta: $("#infoClube").html() };
                                        this.ajax.postAcaoSemResposta(App.Util.config.urlNotificacaoCaptcha, dados);
                                        if (teste) {
                                            App.Sniper.testeSniper.captcha = true;
                                        }
                                    }

                                    if (teste && App.Util.inArray(resultado.response.status, [401, 403])) {
                                        App.Sniper.testeSniper.naoAutenticado = true;
                                    }

                                    if (teste && App.Util.inArray(resultado.response.status, [512, 521, 426, 429])) {
                                        App.Sniper.testeSniper.softbanBusca = true;
                                    }
                                }
                                if (teste) {
                                    this.continuarTeste();
                                } else if (App.Sniper.ehJogadorEspecial && !this.modoPotenteDeBuscaDeJogadorEspecial()) {
                                    App.Sniper.passoPagina = resultado.passoPagina;
                                    App.Sniper.indiceQuantidadePaginas = resultado.indiceQuantidadePaginas;
                                }
                                break;
                            case "compra":
                                if (resultado.status) {
                                    if (!teste) {
                                        try {
                                            this.salvarSnipada(resultado);
                                        }
                                        catch (err) {
                                        }
                                    }
                                    App.Sniper.descansoDeCompra = 5 - parseInt((this.getMilesegundos()).toString()[0]);
                                    this.addQuantidadeCompras(resultado.item);
                                    this.processarDisponibilidadesDeListas();
                                    App.Sniper.itensExpiradosOuComprados.push(resultado.item.tradeId);

                                    if (!teste) {
                                        this.atualizarJogadoresClube(resultado.item.itemData);
                                        this.atualizarDadosAposCompraModoCompraDme(resultado);
                                    }

                                    this.atualizarCreditos(resultado.response);

                                    if (App.Sniper.vendaAutomaticaAtiva && !App.Sniper.ehConsumiveis) {
                                        this.adicionarNaFilaDeVenda(resultado.response.auctionInfo[0]);
                                    }
                                } else {
                                    //Se perder a disputa
                                    if (resultado.response.status == 461) {
                                        App.Sniper.errorsCompraSequencia = 0;
                                        if (!App.Util.inArray(resultado.item.tradeId, App.Sniper.itensExpiradosOuComprados)) {
                                            App.Sniper.salvarLogDisputaPerdida($("#espacoLogs"), resultado.item);
                                            App.Sniper.itensExpiradosOuComprados.push(resultado.item.tradeId);
                                        }
                                    } else {
                                        App.Sniper.errorsCompraSequencia++;
                                        if (!teste && App.Sniper.errorsCompraSequencia <= 3) {
                                            return;
                                        }

                                        App.Sniper.processarTrava();
                                        if (!teste) {
                                            App.Sniper.exibirMensagemSnipeTravado("Sistema travado por segurança, aparentemente o seu WEB APP está pesquisando jogador mas não consegue comprar, pode ser um bloqueio temporário, verique no seu WEB APP.");
                                        }
                                        this.pararTudo();
                                        if (teste && App.Util.inArray(resultado.response.status, [512, 521, 426, 429])) {
                                            App.Sniper.testeSniper.softbanCompra = true;
                                        }
                                    }
                                }
                                if (teste) {
                                    this.continuarTeste();
                                }
                                break;
                        }
                        App.Sniper.tentando = false;
                    });
            }, rand);
        }

        private salvarSnipada(resultado: any) {
            var dados: any = {
                id: App.Util.usuario.id,
                filtro: this.objFiltro,
                configuracoes: App.Sniper.configuracoesAtuais,
                modo_humano: this.modoHumanoAtivo(),
                manter_no_cemiterio: this.modoManterNoCemiterio(),
                modo_potente: 3,
                asset_id: resultado.item.itemData.assetId,
                resource_id: resultado.item.itemData.resourceId,
                nation_id: resultado.item.itemData.nation,
                team_id: resultado.item.itemData.teamid,
                league_id: resultado.item.itemData.leagueId,
                rating: resultado.item.itemData.rating,
                valor: resultado.item.buyNowPrice,
                conta_id: App.Sniper.dadosContaEa.id,
                conta_ptf: App.Sniper.dadosContaEa.ptf,
                status: true,
                created_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
            };
            this.snipadas.push(dados);
            if (this.snipadas.length >= App.Util.config.quantidadeSnipadasAntesSalvar || !App.Sniper.sniperAtivo) {
                this.ajax.postAcaoSemResposta(App.Util.config.urlSalvarSniper, { array_snipadas: this.snipadas });
                this.snipadas = [];
                try {
                    this.atualizarBanometro();
                } catch (e) {
                    console.log("Erro ao atualizar Banômetro", e);
                }
            }
        }

        private atualizarDadosAposCompraModoCompraDme(resultado: any) {
            if (this.modoCompraElencoDme) {
                App.Sniper.finalizarTentativasSniper();
                App.Sniper.totalGastoCompraDme += parseInt(resultado.item.buyNowPrice);
                this.dadosForm.jogador = App.Util.arrayRemove(this.dadosForm.jogador, resultado.item.itemData.assetId);
                $("#jogador option[value='" + resultado.item.itemData.assetId + "']").remove();
                this.addInfoPrecoSelectJogadores(App.Util.elencoDme.elenco);
                var indexItemElencoDme = App.Util.getIndiceArrayByAssetId(App.Util.elencoDme.elenco, resultado.item.itemData.assetId);
                this.objFiltro.maskedDefId = this.dadosForm.jogador[0];
                if ($("#jogador").select2('data').length <= 0) {
                    this.pararTudo();
                    setTimeout(() => {
                        $("#espacoLogs").prepend(App.Sniper.getConteudoLogTerminouComprasItensDme());
                    }, 3000);
                }
            }
        }
        private adicionarNaFilaDeVenda(itemComprado: any) {
            var valorLanceMinimo = App.Util.obterInteiroDaString(this.elCampoValorLanceMinimoVenda.val());
            var valorVenda = App.Util.obterInteiroDaString(this.elCampoValorVenda.val());
            valorLanceMinimo = $.isNumeric(valorLanceMinimo) ? valorLanceMinimo : null;
            valorVenda = $.isNumeric(valorVenda) ? valorVenda : null;

            App.Sniper.arrayItensVendaAutomatica.push({
                auctionInfo: itemComprado,
                duracao: 3600,
                valorLanceMinimo: valorLanceMinimo,
                valorVenda: valorVenda
            });
        }

        private aoIncrementarValor(e: JQueryEventObject) {
            var campoValor = $(e.currentTarget).parents('.input-group').find('input');
            var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min')
            if (App.Util.ehCampoTextoVazio(campoValor)) {
                campoValor.val(campoValorMin).trigger('input').trigger('focusout').trigger('change');
                return;
            }

            var valor = App.Util.obterInteiroDaString(campoValor.val());
            if (!$.isNumeric(valor)) {
                return;
            }
            var campoValorIncrementado = App.Util.incrementarValorDeFiltro(valor);
            campoValor.val(campoValorIncrementado).trigger('input').trigger('focusout').trigger('change');
        }

        private aoDecrementarValor(e: JQueryEventObject) {
            var campoValor = $(e.currentTarget).parents('.input-group').find('input');
            var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min');
            var valor = App.Util.obterInteiroDaString(campoValor.val());
            if (!$.isNumeric(valor)) {
                return;
            }

            if (valor <= campoValorMin) {
                campoValor.val('').trigger('input').trigger('focusout').trigger('change');;
                return;
            }

            var campoValorDecrementado = App.Util.decrementarValorDeFiltro(valor);
            campoValor.val(campoValorDecrementado).trigger('input').trigger('focusout').trigger('change');;
        }

        private registrarEvento(id: number, nome: string) {
            // Snipando pela extensão
            chrome.runtime.sendMessage(this.idExtensao, { evento: id, nome: nome },
                (resultado: any) => {
                });
        }

        private salvarContaEa() {
            var obj: any = App.Sniper.dadosContaEa;
            obj.clube = App.Sniper.dadosContaEa.clube ? App.Sniper.dadosContaEa.clube : App.Sniper.dadosUserInfoEa.usermassinfo.userInfo.clubName;
            this.ajax.postAcaoSemResposta(App.Util.config.urlSalvarContaEa, obj);
        }

        /**
         * Identifica se o usuario está com a aba da pagina visivel ou não
         */
        private handleVisibilityChange() {
            var hidden: string, visibilityState: string, visibilityChange: string;

            if (typeof document.hidden !== "undefined") {
                hidden = "hidden", visibilityChange = "visibilitychange", visibilityState = "visibilityState";
            }
            else if (typeof document.mozHidden !== "undefined") {
                hidden = "mozHidden", visibilityChange = "mozvisibilitychange", visibilityState = "mozVisibilityState";
            }
            else if (typeof document.msHidden !== "undefined") {
                hidden = "msHidden", visibilityChange = "msvisibilitychange", visibilityState = "msVisibilityState";
            }
            else if (typeof document.webkitHidden !== "undefined") {
                hidden = "webkitHidden", visibilityChange = "webkitvisibilitychange", visibilityState = "webkitVisibilityState";
            }

            document.addEventListener(visibilityChange, () => {
                switch (document.visibilityState) {
                    case "visible":
                        this.registrarEvento(App.Sniper.eventoAppContextoStart, 'view_context_app');
                        break;
                    case "hidden":
                        this.registrarEvento(App.Sniper.eventoAppContextoStop, 'view_context_app');
                        break;
                }
            });
        }

        public static registrarDadosDaContaEa() {
            $('#infoClube').html(App.Sniper.dadosUserInfoEa.usermassinfo.userInfo.clubName);
            $('#infoCoins, .info-coins').html(App.Sniper.dadosUserInfoEa.usermassinfo.userInfo.credits.toLocaleString('pt-BR'));
            App.Sniper.capacidadeLimiteListaDeObservacao = 100 - 5;
            App.Sniper.capacidadeListaDeObservacao = App.Util.usuario.configuracaoConta.manter_no_cemiterio ? App.Sniper.capacidadeLimiteListaDeObservacao : App.Sniper.capacidadeHumanaListaDeObservacao;
            App.Sniper.quantidadeAtualListaDeTransferencia = App.Sniper.dadosListaTransferenciaEa.auctionInfo.length;
            App.Sniper.quantidadeAtualListaDeObservacao = App.Sniper.dadosUserInfoEa.usermassinfo.purchasedItems.itemData.length;
            App.Sniper.capacidadeListaDeTransferencia = 100;
            $('#infoListaObservacao, .info-lista-observacao').html(App.Sniper.quantidadeAtualListaDeObservacao + "/" + App.Sniper.capacidadeListaDeObservacao);
            $('#infoListaTransferencia, .info-lista-transferencia').html(App.Sniper.quantidadeAtualListaDeTransferencia + "/" + App.Sniper.capacidadeListaDeTransferencia);
            App.Sniper.quantidadeDisponivelListaDeObservacao = App.Sniper.capacidadeListaDeObservacao - App.Sniper.quantidadeAtualListaDeObservacao;
            App.Sniper.quantidadeDisponivelListaDeTransferencia = App.Sniper.capacidadeListaDeTransferencia - App.Sniper.quantidadeAtualListaDeTransferencia;
        }

        private incrementarQuantidadeDisponivelListaDeObservacao() {
            if (App.Sniper.quantidadeDisponivelListaDeObservacao >= App.Sniper.capacidadeListaDeObservacao) {
                return;
            }

            App.Sniper.quantidadeDisponivelListaDeObservacao++;
            $('#infoListaObservacao, .info-lista-observacao').html((App.Sniper.capacidadeListaDeObservacao - App.Sniper.quantidadeDisponivelListaDeObservacao).toString() + "/" + App.Sniper.capacidadeListaDeObservacao);
        }
        private decrementarQuantidadeDisponivelListaDeObservacao() {
            if (App.Sniper.quantidadeDisponivelListaDeObservacao == 0) {
                return;
            }

            App.Sniper.quantidadeDisponivelListaDeObservacao--;
            $('#infoListaObservacao, .info-lista-observacao').html((App.Sniper.capacidadeListaDeObservacao - App.Sniper.quantidadeDisponivelListaDeObservacao).toString() + "/" + App.Sniper.capacidadeListaDeObservacao);
        }
        private incrementarQuantidadeDisponivelListaDeTransferencia() {
            App.Sniper.quantidadeDisponivelListaDeTransferencia++;
            $('#infoListaTransferencia, .info-lista-transferencia').html((App.Sniper.capacidadeListaDeTransferencia - App.Sniper.quantidadeDisponivelListaDeTransferencia).toString() + "/" + App.Sniper.capacidadeListaDeTransferencia);
        }
        private decrementarQuantidadeDisponivelListaDeTransferencia() {
            App.Sniper.quantidadeDisponivelListaDeTransferencia--;
            var quantidadeListaTransf = (App.Sniper.capacidadeListaDeTransferencia - App.Sniper.quantidadeDisponivelListaDeTransferencia);
            $('#infoListaTransferencia, .info-lista-transferencia').html((quantidadeListaTransf > 100 ? "100" : quantidadeListaTransf.toString()) + "/" + App.Sniper.capacidadeListaDeTransferencia);
        }

        private inicializarQuantidadeCompraDiaria() {
            $('#infoComprasDia, .info-compras-dia').html(App.Util.usuario.quantidadeComprasDoDia.toString());
        }
        private incrementarQuantidadeCompraDiaria() {
            App.Util.usuario.quantidadeComprasDoDia++;
            $('#infoComprasDia, .info-compras-dia').html(App.Util.usuario.quantidadeComprasDoDia.toString());
            if (!App.Util.config.naoValidarPlano && App.Util.usuario.quantidadeComprasDoDia >= App.Util.usuario.plano.configuracoes.quantidadeLimiteComprasDiarias) {
                this.pararTudo();
                $("#espacoLogs").prepend(App.Sniper.getConteudoLogQuantidadeComprasDiariasAtingida());
            }
        }

        private modoHumanoAtivo(): boolean {
            return App.Util.usuario.configuracao.modo_humano;
        }

        private modoPotenteDeBuscaDeJogadorEspecial(): boolean {
            return false;
        }

        private modoManterNoCemiterio(): boolean {
            return App.Util.usuario.configuracaoConta.manter_no_cemiterio;
        }

        private uso3HorasHabilitado(): boolean {
            return App.Util.usuario.configuracao.uso_3_horas;
        }

        private aoClicarLinkFiltrosIndisponiveis() {
            this.exibirMensagemAlertaSwal("Serviço indisponível", "Os serviços salvar ou aplicar filtro não estão disponíveis no <b>" + this.elSniperPage.data('nomePlano') + "</b>, Esse serviço está disponível para assinantes do <b>Plano Prata ou Ouro</b>.", "warning", "Ver Planos", "Fechar", '#2dce89', true, this.elSniperPage.data('urlPlanos'));
        }

        public static exibirLoadingSniperApp() {
            App.Sniper.elSpinner.show();
        }

        public static ocultarLoadingSniperApp() {
            App.Sniper.elSpinner.hide();
        }

        private revincularContaEa(contaEa: any) {
            this.ajax = new App.Ajax();
            this.ajax.postAcaoSemCabecalhoGlobal(App.Util.config.urlRevincularConta, { id: contaEa.id });
        }

        private atualizarDadosWebApp(request: any) {
            // Verificar aqui navamente se o cara trocou de conta, não podemos permitir com sniper funcionando
            if (App.Sniper.dadosContaEa && request.hasOwnProperty('tipo') && request.tipo == "usermassinfo" && request.dados.hasOwnProperty('userInfo') && request.dados.userInfo.personaId != App.Sniper.dadosContaEa.id) {
                App.Sniper.dadosContaEa.id = request.dados.userInfo.personaId;
                $("#infoClube").html(request.dados.userInfo.clubName);
                this.pararCompra(false);
                this.validarPlano(null);
            }

            switch (request.tipo) {
                case "tradepile":
                    this.atualizarListaTransferencia(request.dados);
                    break;
                case "usermassinfo":
                    this.atualizarListaObservacao(request.dados);
                    break;
                case "item":
                    if (App.Util.isset(request.dados.itemData) && $.isArray(request.dados.itemData)) {
                        $.each(request.dados.itemData, (posicao, item) => {
                            if (item.pile == "trade") {
                                this.decrementarQuantidadeDisponivelListaDeTransferencia();
                                if (request.listaObservacao) {
                                    this.incrementarQuantidadeDisponivelListaDeObservacao();
                                }
                            }
                        });
                    }
                    break;
                case "removevendido":
                    this.incrementarQuantidadeDisponivelListaDeTransferencia();
                    break;
                case "club":
                    if (request.dados.hasOwnProperty('category') && request.dados.category == "club" && request.dados.hasOwnProperty('stat')) {
                        var playersClube = App.Util.getItemArrayByType(request.dados.stat, "players");
                        this.totalJogadoresGuardadosClube += playersClube.hasOwnProperty('typeValue') ? playersClube.typeValue : 0;
                        if (this.totalJogadoresGuardadosClube <= 32) {
                            this.finalizarProcessoInformacaoJogadoresElenco();
                        }
                    } else if (request.dados.hasOwnProperty('itemData') && Array.isArray(request.dados.itemData)) {
                        this.atualizarJogadoresClube(request.dados.itemData);
                        if (this.totalJogadoresGuardadosClube === null) {
                            this.totalJogadoresGuardadosClube = 0;
                            this.totalJogadoresGuardadosClube -= request.dados.itemData.length;
                        } else {
                            this.totalJogadoresGuardadosClube -= request.dados.itemData.length;
                            if (this.totalJogadoresGuardadosClube !== null && this.totalJogadoresGuardadosClube <= 0) {
                                this.finalizarProcessoInformacaoJogadoresElenco();
                            }
                        }
                    }
                    break;
                case "credits":
                    this.atualizarCreditos(request.dados);
                    break;
                case "completouauthconta":
                    if (request.hasOwnProperty('conta') && request.conta) {
                        App.Sniper.dadosContaEa = request.conta;
                        App.Sniper.dadosContaEa.ptf = App.Util.getNomePlataforma(App.Sniper.dadosContaEa.ptf);
                        this.atualizarExibicaoClubeAtual();
                        if (App.Sniper.ehVendaCoins) {
                            this.obterContasEa(App.Sniper.dadosContaEa, this.calcularCoinsTotais);
                        }
                    }
                case "errosincronizacao":
                    if (App.Sniper.sniperAtivo) {
                        this.pararTudo();
                        this.exibirLogErroProblemaSincronizacao();
                    }
                    break;
            }
        }

        private exibirLogErroProblemaSincronizacao() {
            $("#espacoLogs").prepend('<span class="badge badge-pill badge-warning text-uppercase">Problema</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Houve um problema na sincronização da conta, Faça login novamente na sua conta EA e depois recarregue essa página</p>');
        }


        private atualizarExibicaoClubeAtual() {
            if (App.Sniper.dadosContaEa) {
                $(".info-nome-clube").html(App.Sniper.dadosContaEa.clube);
                $('#infoCoins, .info-coins').html(App.Sniper.dadosContaEa.coins ? App.Sniper.dadosContaEa.coins.toLocaleString('pt-BR') : null);
                $('#infoPlataforma, .info-plataforma').html(App.Sniper.dadosContaEa.ptf.toString());
            }
        }
        private atualizarJogadoresClube(jogadoresOuJogador: any) {
            if (Array.isArray(jogadoresOuJogador)) {
                $.each(jogadoresOuJogador, function(index: any, jogador: any) {
                    if (jogador.hasOwnProperty('itemData')) {
                        jogador.itemData.local = 'Lista Transferência/Observação';
                    } else {
                        jogador.local = 'Clube';
                    }

                    App.Sniper.arrayJogadoresClube = App.Util.arrayRemoveByResourceId(App.Sniper.arrayJogadoresClube, (jogador.hasOwnProperty('resourceId') ? jogador.resourceId : jogador.itemData.resourceId));
                    App.Sniper.arrayJogadoresClube.push((jogador.hasOwnProperty('resourceId') ? jogador : jogador.itemData));
                });
            } else if (typeof jogadoresOuJogador === 'object' && jogadoresOuJogador !== null) {
                if (jogadoresOuJogador.hasOwnProperty('itemData')) {
                    jogadoresOuJogador.itemData.local = 'Lista Transferência/Observação';
                } else {
                    jogadoresOuJogador.local = 'Clube';
                }
                App.Sniper.arrayJogadoresClube = App.Util.arrayRemoveByResourceId(App.Sniper.arrayJogadoresClube, (jogadoresOuJogador.hasOwnProperty('resourceId') ? jogadoresOuJogador.resourceId : jogadoresOuJogador.itemData.resourceId));
                App.Sniper.arrayJogadoresClube.push((jogadoresOuJogador.hasOwnProperty('resourceId') ? jogadoresOuJogador : jogadoresOuJogador.itemData));
            }
            App.Util.setArrayStorage(App.Sniper.keyStorageJogadoresClube, App.Sniper.arrayJogadoresClube);
        }
        private atualizarCreditos(dados: any) {
            if (dados.hasOwnProperty('credits')) {
                $('#infoCoins, .info-coins').html(dados.credits.toLocaleString('pt-BR'));
            }
        }
        private atualizarListaTransferencia(dadosLista: any) {
            App.Sniper.quantidadeAtualListaDeTransferencia = dadosLista.auctionInfo.length;
            $('#infoListaTransferencia, .info-lista-transferencia').html(App.Sniper.quantidadeAtualListaDeTransferencia + "/" + App.Sniper.capacidadeListaDeTransferencia);
            App.Sniper.quantidadeDisponivelListaDeTransferencia = App.Sniper.capacidadeListaDeTransferencia - App.Sniper.quantidadeAtualListaDeTransferencia;
        }

        private atualizarListaObservacao(dadosLista: any) {
            $('#infoCoins, .info-coins').html(dadosLista.userInfo.credits.toLocaleString('pt-BR'));
            App.Sniper.quantidadeAtualListaDeObservacao = dadosLista.purchasedItems.itemData.length;
            $('#infoListaObservacao, .info-lista-observacao').html(App.Sniper.quantidadeAtualListaDeObservacao + "/" + App.Sniper.capacidadeListaDeObservacao);
            App.Sniper.quantidadeDisponivelListaDeObservacao = App.Sniper.capacidadeListaDeObservacao - App.Sniper.quantidadeAtualListaDeObservacao;
        }

        /**
         * Soluções de problemas
         */
        private inicializarSolucoesDeProblemas() {
            this.elementoBotaoTesteProblemas.on('click', (e) => { this.iniciarAnalise(e); });
        }

        private removerLinkCarregamentoIncompletoScripts() {
            $('#problemaCarregamentoScripts').hide();
        }

        private inicializarLimpezaCache() {
            this.elementoBotaoLimparCache.on('click', (e) => {
                chrome.runtime.sendMessage(this.idExtensao, { evento: "lpcache" },
                    (resposta: any) => {
                        $("#modalSolucaoproblemas").modal('hide');
                        this.exibirMensagemAlertaSwal("Limpeza completa!", "Você será redirecionado para fazer uma nova autenticação e sincronizar sua conta EA com FutSniperWeb novamente.", "warning", "Sincronizar novamente", "Fechar", '#3740FF', false, resposta.urlWebApp);
                        setTimeout(() => {
                            window.location.href = resposta.urlWebApp;
                        }, 7000);
                    });
            });
        }

        private iniciarAnalise(e: JQueryEventObject) {
            this.inicializarConfiguracoes();
            App.Sniper.testeSniper.softbanBusca = false;
            App.Sniper.testeSniper.softbanCompra = false;
            App.Sniper.testeSniper.captcha = false;
            App.Sniper.testeSniper.naoAutenticado = false;
            App.Sniper.elCampoNoUiSliderVelocidade.noUiSlider.set(2000);
            App.Sniper.contexto = this;
            this.proximaVerificacao(this.elementoPassoExtensaoInstalada, this.verificarExtensaoInstalada,
                () => {
                    this.proximaVerificacao(this.elementoPassoExtensaoAtualizada, this.verificarExtensaoAtualizada,
                        () => {
                            $(this.elementoPassoAutenticacao).find('.badge-aguardando').hide();
                            $(this.elementoPassoAutenticacao).find('.badge-loading').show();
                            this.testarSniper();
                        });
                });
        }
        private proximaVerificacao(e: JQuery, validar: any, proximaVerificacao: any = null): any {
            $(e).find('.badge-aguardando').hide();
            $(e).find('.badge-loading').show();
            setTimeout(() => {
                if (!validar()) {
                    $(e).find('.badge-loading').hide();
                    $(e).find('.badge-erro').show();
                    $(e).find('.texto-erro').show();
                    return false;
                } else {
                    $(e).find('.badge-loading').hide();
                    $(e).find('.badge-sucesso').show();
                    if (proximaVerificacao) {
                        proximaVerificacao();
                    }
                }
            }, 1000);
        }
        private verificarExtensaoInstalada(): boolean {
            return $('#idExtensao').val() != "";
        }
        private verificarExtensaoAtualizada(): boolean {
            return !App.Sniper.ehVersaoDesatualizadaExtensao();
        }
        private testarSniper() {
            if (App.Sniper.sniperTravado != 1 && App.Sniper.dadosContaEa.autenticada) {
                App.Sniper.contexto.snipar($.Event("submit"), false, true);
            } else {
                App.Sniper.testeSniper.naoAutenticado = true;
                this.continuarTeste();
            }
        }

        private continuarTeste() {
            this.proximaVerificacao(this.elementoPassoAutenticacao, this.verificarSeEstaAutenticado,
                () => {
                    this.proximaVerificacao(this.elementoPassoBuscaDeItem, this.verificarSeEstaBuscando,
                        () => {
                            this.proximaVerificacao(this.elementoPassoCompraDeItem, this.verificarSeEstaComprando,
                                () => {
                                    this.finalizarTeste();
                                });
                        });
                });
        }

        private verificarSeEstaAutenticado(): boolean {

            return !App.Sniper.testeSniper.naoAutenticado;
        }

        private verificarSeEstaBuscando(): boolean {
            return !App.Sniper.testeSniper.softbanBusca;
        }

        private verificarSeEstaComprando(): boolean {
            return !App.Sniper.testeSniper.softbanCompra;
        }

        private finalizarTeste(): void {
            $("#testeCompleto").show();
        }
        private adicionarElencoDeDme(elenco: IElencoDme[]) {
            if (elenco.length > 1) {
                var preenchido = false;
                $("#searchclear").click();
                var i = 0;
                $.each(elenco, (index: any, item: IElencoDme) => {
                    if (App.Util.arrayExistByResourceId(App.Sniper.arrayJogadoresClube, item.id.toString())) {
                        if (!$('#abaLog').hasClass('active')) {
                            $('#abaLog').click();
                        }
                        App.Sniper.salvarLogJogadorJaExiste($("#espacoLogs"), item);
                        i++;
                    } else if (item.id != item.assetId) {
                        if (!$('#abaLog').hasClass('active')) {
                            $('#abaLog').click();
                        }
                        App.Sniper.salvarLogJogadorEspecialNaoCompramos($("#espacoLogs"), item);
                        i++;
                    } else {
                        var player = App.Util.getItemArrayById(App.Sniper.players, parseInt(item.assetId.toString()));
                        i++;
                        if (!App.Util.empty(player)) {
                            var option = new Option(JSON.stringify(player), player.id, true, true);
                            option.title = player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l;
                            $("#jogador").append(option).trigger('change').trigger('select2:select');
                            if (i === (elenco.length)) {
                                preenchido = true;
                                this.addInfoPrecoSelectJogadores(elenco);
                            }
                        }
                    }
                });

            }
        }
        private addInfoPrecoSelectJogadores(elenco: IElencoDme[]): void {
            setTimeout(() => {
                $.each(elenco, (index: any, itemElencoDme: any) => {
                    var precoMaisBarato = this.obterValorMaisBaratoPorPorcentagem(itemElencoDme, itemElencoDme.porcentagemMaisBarato);
                    var spans = '<span title="Preço mais barato" id="span" class="nav-item badge badge-pill text-muted badge-success" style="color: #0a9b3d !important;"><span class="description">' + precoMaisBarato + ' coins</span></span><span title="Preço no DME" id="span" class="nav-item badge badge-pill text-muted badge-primary" style="color: #497499 !important;"><span class="description">' + itemElencoDme.preco + ' coins</span></span>';
                    $("#item" + itemElencoDme.assetId.toString()).find('a').append(spans);
                    if (index == (elenco.length - 1)) {
                        $(".select2-search, .select2-focusser, .select2-results__options").remove();
                    }
                });
            }, 1000);
        }

        private exibirDetalhesLoadJogador(itemElencoDme: IElencoDme) {
            $('#cardLoadDetalhesOferta').html(itemElencoDme.preco.toString());
            $('#cardLoadDetalhesNomeJogador').html(itemElencoDme.nome.toString());
            $('#cardLoadDetalhesImgJogador').attr('src', $('#item' + itemElencoDme.assetId).find('.playerpicture').attr('src'));
            $('#cardLoadDetalhesPrecoInicial').html(itemElencoDme.precoInicial.toString() + " coins");
            $('#cardLoadDetalhesPrecoPocentagem').html(itemElencoDme.porcentagemMaisBarato.toString() + "%");
            $('#cardLoadDetalhesJogador').show();
        }

        private aoSelecionarCampoQualidade(e: any) {
            var qualidadeSelecionada = $(e.target).val();
            if (qualidadeSelecionada == "bronze" || qualidadeSelecionada == "silver" || qualidadeSelecionada == "gold") {
                $('#raridade').find('option.categoria2').attr('disabled', 'disabled');
                $('#raridade').find('option.categoria1').removeAttr('disabled');
            } else if (qualidadeSelecionada == "SP") {
                $('#raridade').find('option.categoria1').attr('disabled', 'disabled');
                $('#raridade').find('option.categoria2').removeAttr('disabled');
            } else {
                $('#raridade').find('option.categoria1').removeAttr('disabled');
                $('#raridade').find('option.categoria2').removeAttr('disabled');
            }

            $("#raridade").select2("destroy");
            $("#raridade").select2({
                width: '100%',
                templateResult: formatOptionsSelect,
                templateSelection: formatOptionsSelect
            });
            $('#raridade').val('').trigger('change').trigger('select2:select');
        }

        private aoExibirModoCompraElenco(e: JQueryEventObject) {
            $("#limparFiltro").click();
            this.desabilitarVendaAutomatica();
            $("#espacoConteudoComposFiltros").hide();
            $("#conteudoGeralVendaAutomatica").hide();
            $('#conteudoOfertaCompra').hide();
            $("#btExibirModoCompraElenco").find('.text-modo-compra-elenco').show();
            $("#btExibirModoCompraElenco").find('.text-modo-compra-jogador').hide();
        }
        private aoOcultarModoCompraElenco(e: JQueryEventObject) {
            document.location.reload(true);
        }

        private inicializarVendaDeCoins() {
            this.obterContasEa();
            if (App.Sniper.ehVendaCoins) {
                var vendaCoins = new App.VendaCoins();
                vendaCoins.inicializarEventos(this.idExtensao, this);
            }
        }

        private obterContasEa(contaAtualAutenticada: IContaEa = null, metodoCallback: any = null) {
            chrome.runtime.sendMessage(this.idExtensao, { evento: "ctsaut" },
                (resultado: any) => {
                    App.Sniper.contasEa = resultado.contas;
                    this.verificarProcessarContas(contaAtualAutenticada, metodoCallback);
                });
        }

        private verificarProcessarContas(contaAtualAutenticada: IContaEa = null, metodoCallback: any = null) {
            if (contaAtualAutenticada) {
                if (contaAtualAutenticada.autenticada) {
                    this.exibirContaAutenticada(contaAtualAutenticada);
                    this.autenticando = false;
                    this.exibirMensagemAlertaSwal("Conta Autenticada!", "Sua conta <b>" + contaAtualAutenticada.clube + "</b> foi autenticada.", "success", "OK", "Fechar", "#2dce89", false);
                } else {
                    this.exibirContaNaoAutenticada(contaAtualAutenticada);
                }
                if (metodoCallback) {
                    metodoCallback();
                }
            } else {
                App.Sniper.coinsTotal = 0;
                $.each(App.Sniper.contasEa, (index: any, conta: any) => {
                    if (conta.coins) {
                        App.Sniper.coinsTotal += conta.coins;
                    }

                    if (conta.autenticada) {
                        this.exibirContaAutenticada(conta);
                    } else {
                        this.exibirContaNaoAutenticada(conta);
                    }
                });
            }
        }

        private calcularCoinsTotais() {
            App.Sniper.coinsTotal = 0;
            $.each(App.Sniper.contasEa, (index: any, conta: any) => {
                App.Sniper.coinsTotal += conta.coins;
                $("#infoCoinsTotais").html(App.Sniper.coinsTotal.toLocaleString('pt-BR'));
            });
        }
        private exibirContaAutenticada(conta: IContaEa) {
            $('#conta' + conta.id).find('.info-autenticada').html('Autenticada');
            $('#conta' + conta.id).find('.checklist-item').removeClass('checklist-item-warning').addClass('checklist-item-success');
            $('#conta' + conta.id).find('.status-autenticada').removeClass('text-warning').addClass('text-success');
            $('#conta' + conta.id).find('.btn-autenticar-conta').hide();
            $('#conta' + conta.id).find('.coins-conta').show();
            $('#conta' + conta.id).find('.coins').html(conta.coins.toLocaleString('pt-BR'));
            $("#infoCoinsTotais").html(App.Sniper.coinsTotal.toLocaleString('pt-BR'));
        }

        private exibirContaNaoAutenticada(conta: IContaEa) {
            $('#conta' + conta.id).find('.info-autenticada').html('Não autenticada');
            $('#conta' + conta.id).find('.checklist-item').removeClass('checklist-item-success').addClass('checklist-item-warning');
            $('#conta' + conta.id).find('.status-autenticada').removeClass('text-success').addClass('text-warning');
            $('#conta' + conta.id).find('.btn-autenticar-conta').show();
            $('#conta' + conta.id).find('.coins-conta').hide();
            $('#conta' + conta.id).find('.coins').html('0');
        }
        private aoClicarEmAutenticarConta(e: JQueryEventObject) {
            chrome.runtime.sendMessage(this.idExtensao, { evento: "lcarwp" },
                (resposta: any) => {
                    this.autenticando = true;
                });
        }

        public comprarItemTransferindoCoins(item: IItemTransferenciaCoins, metodoCallback: any) {
            chrome.runtime.sendMessage(this.idExtensao, { evento: "cpitemtrans", dados: this.getObjetoFiltroTransferenciaCoins(item), tradeId: item.tradeID, dadosEa: App.Sniper.dadosContaEa, ofertaCompra: App.Sniper.maxbInicial, itensExpiradosOuComprados: App.Sniper.itensExpiradosOuComprados },
                (resultado: any) => {
                    if (App.Sniper.itensExpiradosOuComprados.length >= 10) {
                        App.Sniper.itensExpiradosOuComprados = [];
                    }
                    switch (resultado.tipo) {
                        case "itemNaoEncontrado":
                            //Se buscou corretamente
                            if (resultado.status) {
                                App.Sniper.errorsSequencia = 0;
                                metodoCallback(resultado);
                            } else {
                                App.Sniper.errorsSequencia++;
                                App.Sniper.processarTrava();

                                this.pararTudo();

                                /**
                                 * Se for um pedido de captcha da EA
                                 */
                                if (resultado.response.status == 458) {
                                    $("#espacoLogs").prepend(App.Sniper.getConteudoLogCaptcha());
                                    var dados: any = { id: App.Util.usuario.id, nome_conta: $("#infoClube").html() };
                                    this.ajax.postAcaoSemResposta(App.Util.config.urlNotificacaoCaptcha, dados);
                                }
                            }
                            break;
                        case "compra":
                            if (resultado.status) {
                                metodoCallback(resultado);
                                this.incrementarQuantidadeCompraDiaria();
                                this.processarDisponibilidadesDeListas();
                                App.Sniper.itensExpiradosOuComprados.push(resultado.item.tradeId);
                            } else {
                                //Se perder a disputa
                                if (resultado.response.status == 461) {
                                    App.Sniper.errorsCompraSequencia = 0;
                                    if (!App.Util.inArray(resultado.item.tradeId, App.Sniper.itensExpiradosOuComprados)) {
                                        App.Sniper.salvarLogDisputaPerdida($("#espacoLogs"), resultado.item);
                                        App.Sniper.itensExpiradosOuComprados.push(resultado.item.tradeId);
                                    }
                                } else {
                                    App.Sniper.errorsCompraSequencia++;
                                    App.Sniper.processarTrava();

                                    this.pararTudo();
                                }
                            }
                            break;
                    }
                });
        }

        private getPlayers(metodoCallback: any) {
            const hoje = new Date();
            const parametroCache = `${hoje.getFullYear()}-${hoje.getMonth() + 1}-${hoje.getDate()}`; // Gera o parâmetro baseado na data atual
            $.getJSON("/players.json", { _: parametroCache }, (data) => {
                App.Sniper.players = data.Players;
                metodoCallback();
            });
        }
        private aoAbrirModalUso(e: JQueryEventObject) {
            $("#infoRisco #gauge").remove();
            $("#gauge").clone().appendTo("#infoRisco");
        }
    }
}
